import React, { useState, useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";

import { db, auth, messaging, storage, functionsInstance } from "./firebase";
import { httpsCallable } from "firebase/functions";
import { getToken, onMessage } from "firebase/messaging";

// Validazione formale P.IVA italiana (algoritmo ufficiale a 11 cifre)
function isValidPartitaIva(piva) {
  if (!/^\d{11}$/.test(piva)) return false;
  let sum = 0;
  for (let i = 0; i < 10; i++) {
    let digit = parseInt(piva[i], 10);
    if (i % 2 === 1) {
      digit *= 2;
      if (digit > 9) digit -= 9;
    }
    sum += digit;
  }
  const checkDigit = (10 - (sum % 10)) % 10;
  return checkDigit === parseInt(piva[10], 10);
}
import { Capacitor } from "@capacitor/core";
import { PushNotifications } from "@capacitor/push-notifications";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

import {
  collection,
  getDocs,
  addDoc,
  onSnapshot,
  query,
  where,
  deleteDoc,
  doc,
  getDoc,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
  sendPasswordResetEmail,
  sendEmailVerification,
} from "firebase/auth";

// CSS Leaflet va in public/index.html:
// <link rel="stylesheet" href="https://unpkg.com/leaflet@1.9.4/dist/leaflet.css"/>

const style = `
  @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=DM+Sans:wght@300;400;500;700&display=swap');
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  :root {
    --bg: #0a0a0a; --surface: #141414; --surface2: #1e1e1e; --border: #2a2a2a;
    --orange: #ff6b35; --cream: #f5f0eb; --muted: #666; --green: #39d353; --red: #ff4d4d;
    --font-display: 'Bebas Neue', sans-serif; --font-body: 'DM Sans', sans-serif;
    --radius: 16px; --radius-sm: 10px;
  }
  body { background: var(--bg); color: var(--cream); font-family: var(--font-body); min-height: 100vh; }
  .grain { position: fixed; inset: 0; pointer-events: none; z-index: 9999; background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)' opacity='0.04'/%3E%3C/svg%3E"); opacity: 0.35; }
  @keyframes fadeIn { from{opacity:0;transform:translateY(12px)} to{opacity:1;transform:translateY(0)} }
  @keyframes slideUp { from{opacity:0;transform:translateY(20px)} to{opacity:1;transform:translateY(0)} }
  @keyframes slideSheet { from{transform:translateY(100%)} to{transform:translateY(0)} }
  @keyframes pulse { 0%,100%{filter:drop-shadow(0 0 20px rgba(255,107,53,0.4))} 50%{filter:drop-shadow(0 0 50px rgba(255,107,53,0.8))} }
  @keyframes glow { 0%,100%{box-shadow:0 0 30px rgba(57,211,83,0.3)} 50%{box-shadow:0 0 60px rgba(57,211,83,0.6)} }
  .splash { min-height: 100vh; display: flex; flex-direction: column; align-items: center; justify-content: center; background: radial-gradient(ellipse at 60% 30%, #1a0f08 0%, #0a0a0a 70%); padding: 40px 20px; animation: fadeIn 0.6s ease; }
  .logo-wrap { display: flex; flex-direction: column; align-items: center; margin-bottom: 48px; }
  .logo-icon { font-size: 72px; line-height: 1; animation: pulse 3s ease-in-out infinite; }
  .logo-text { font-family: var(--font-display); font-size: 88px; color: var(--orange); letter-spacing: 6px; line-height: 1; margin-top: -8px; }
  .logo-sub { font-size: 13px; letter-spacing: 4px; color: var(--muted); text-transform: uppercase; margin-top: 6px; }
  .splash-title { font-family: var(--font-display); font-size: 32px; letter-spacing: 2px; color: var(--cream); text-align: center; margin-bottom: 12px; }
  .splash-sub { font-size: 15px; color: var(--muted); text-align: center; margin-bottom: 48px; max-width: 320px; line-height: 1.6; }
  .btn-primary { background: var(--orange); color: #fff; border: none; padding: 16px 36px; border-radius: var(--radius); font-family: var(--font-display); font-size: 22px; letter-spacing: 2px; cursor: pointer; transition: all 0.2s; width: 100%; max-width: 340px; position: relative; overflow: hidden; }
  .btn-primary::after { content:''; position:absolute; inset:0; background:linear-gradient(135deg,rgba(255,255,255,0.1) 0%,transparent 60%); }
  .btn-primary:hover { background: #ff8558; transform: translateY(-2px); box-shadow: 0 8px 30px rgba(255,107,53,0.4); }
  .btn-primary:disabled { opacity: 0.5; cursor: not-allowed; transform: none; }
  .btn-secondary { background: transparent; color: var(--cream); border: 1.5px solid var(--border); padding: 14px 36px; border-radius: var(--radius); font-family: var(--font-body); font-size: 15px; font-weight: 500; cursor: pointer; transition: all 0.2s; width: 100%; max-width: 340px; }
  .btn-secondary:hover { border-color: var(--orange); color: var(--orange); }
  .btn-ghost { background: transparent; color: var(--muted); border: none; font-size: 14px; cursor: pointer; padding: 8px; transition: color 0.2s; }
  .btn-ghost:hover { color: var(--cream); }
  .input-field { background: var(--surface2); border: 1.5px solid var(--border); border-radius: var(--radius-sm); padding: 14px 16px; color: var(--cream); font-family: var(--font-body); font-size: 15px; outline: none; width: 100%; margin-bottom: 12px; transition: border-color 0.2s; }
  .input-field:focus { border-color: var(--orange); }
  .input-field::placeholder { color: var(--muted); }
  .time-input { background: var(--surface2); border: 1.5px solid var(--border); border-radius: var(--radius-sm); padding: 12px 16px; color: var(--cream); font-family: var(--font-body); font-size: 16px; outline: none; width: 100%; margin-bottom: 12px; transition: border-color 0.2s; }
  .time-input:focus { border-color: var(--orange); }
  .error-msg { color: var(--red); font-size: 13px; margin-bottom: 12px; padding: 10px 14px; background: rgba(255,77,77,0.08); border-radius: var(--radius-sm); border: 1px solid rgba(255,77,77,0.2); }
  .sheet-overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.75); z-index: 200; backdrop-filter: blur(4px); animation: fadeIn 0.2s ease; }
  .sheet { position: fixed; bottom: 0; left: 0; right: 0; background: var(--surface); border-radius: 24px 24px 0 0; border-top: 1px solid var(--border); padding: 0 24px 48px; z-index: 201; animation: slideSheet 0.35s cubic-bezier(0.32,0.72,0,1); max-height: 92vh; overflow-y: auto; }
  .sheet-handle { width: 40px; height: 4px; background: var(--border); border-radius: 4px; margin: 14px auto 24px; }
  .sheet-title { font-family: var(--font-display); font-size: 28px; letter-spacing: 2px; color: var(--cream); margin-bottom: 4px; }
  .sheet-sub { font-size: 14px; color: var(--muted); margin-bottom: 24px; }
  .sheet-tabs { display: flex; gap: 0; margin-bottom: 20px; background: var(--surface2); border-radius: var(--radius-sm); padding: 4px; }
  .sheet-tab { flex: 1; padding: 10px; border: none; border-radius: 8px; font-family: var(--font-body); font-size: 13px; font-weight: 600; cursor: pointer; transition: all 0.2s; color: var(--muted); background: transparent; }
  .sheet-tab.active { background: var(--orange); color: white; }
  .role-row { display: flex; gap: 10px; margin-bottom: 16px; }
  .role-pill { flex: 1; padding: 12px 8px; border-radius: var(--radius-sm); border: 1.5px solid var(--border); background: var(--surface2); color: var(--muted); font-size: 13px; font-weight: 600; cursor: pointer; transition: all 0.2s; text-align: center; }
  .role-pill.active { border-color: var(--orange); color: var(--orange); background: rgba(255,107,53,0.08); }
  .wizard { min-height: 100vh; display: flex; flex-direction: column; background: radial-gradient(ellipse at 40% 60%, #120a05 0%, #0a0a0a 65%); }
  .wizard-header { padding: 24px 24px 0; display: flex; align-items: center; gap: 12px; }
  .wizard-back { background: var(--surface2); border: none; color: var(--cream); width: 40px; height: 40px; border-radius: 50%; font-size: 18px; cursor: pointer; display: flex; align-items: center; justify-content: center; }
  .progress-bar { flex: 1; height: 4px; background: var(--surface2); border-radius: 4px; overflow: hidden; }
  .progress-fill { height: 100%; background: var(--orange); border-radius: 4px; transition: width 0.4s cubic-bezier(0.4,0,0.2,1); }
  .wizard-body { flex: 1; padding: 40px 24px 32px; display: flex; flex-direction: column; animation: slideUp 0.35s ease; }
  .wizard-step-label { font-size: 12px; letter-spacing: 3px; text-transform: uppercase; color: var(--orange); margin-bottom: 12px; font-weight: 600; }
  .wizard-question { font-family: var(--font-display); font-size: 38px; letter-spacing: 1px; line-height: 1.1; color: var(--cream); margin-bottom: 8px; }
  .wizard-hint { font-size: 14px; color: var(--muted); margin-bottom: 36px; line-height: 1.5; }
  .options-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-bottom: 32px; }
  .options-grid.single-col { grid-template-columns: 1fr; }
  .option-card { background: var(--surface); border: 1.5px solid var(--border); border-radius: var(--radius); padding: 18px 16px; cursor: pointer; transition: all 0.2s; display: flex; flex-direction: column; align-items: center; gap: 8px; text-align: center; position: relative; overflow: hidden; }
  .option-card:hover { border-color: var(--orange); transform: translateY(-2px); }
  .option-card.selected { border-color: var(--orange); background: rgba(255,107,53,0.08); }
  .option-emoji { font-size: 32px; line-height: 1; }
  .option-label { font-size: 14px; font-weight: 600; color: var(--cream); }
  .option-sub { font-size: 12px; color: var(--muted); line-height: 1.4; }
  .selected-check { position: absolute; top: 10px; right: 10px; width: 20px; height: 20px; border-radius: 50%; background: var(--orange); color: white; font-size: 11px; display: flex; align-items: center; justify-content: center; }
  .onboarding { min-height: 100vh; background: var(--bg); animation: fadeIn 0.4s ease; padding-bottom: 40px; }
  .onboarding-header { background: var(--surface); border-bottom: 1px solid var(--border); padding: 20px 24px; display: flex; align-items: center; gap: 16px; }
  .onboarding-step-dot { width: 8px; height: 8px; border-radius: 50%; background: var(--border); transition: all 0.3s; }
  .onboarding-step-dot.active { background: var(--orange); transform: scale(1.3); }
  .onboarding-step-dot.done { background: var(--green); }
  .onboarding-body { padding: 32px 24px; animation: slideUp 0.3s ease; }
  .onboarding-title { font-family: var(--font-display); font-size: 36px; letter-spacing: 1px; color: var(--cream); margin-bottom: 8px; line-height: 1; }
  .onboarding-sub { font-size: 14px; color: var(--muted); margin-bottom: 32px; line-height: 1.5; }
  .section-mini-label { font-size: 11px; letter-spacing: 3px; text-transform: uppercase; color: var(--orange); font-weight: 600; margin-bottom: 10px; margin-top: 20px; }
  .vendor-home { min-height: 100vh; background: var(--bg); display: flex; flex-direction: column; animation: fadeIn 0.4s ease; }
  .vendor-home-header { background: var(--surface); border-bottom: 1px solid var(--border); padding: 16px 20px; display: flex; align-items: center; justify-content: space-between; position: sticky; top: 0; z-index: 100; }
  .vendor-home-logo { font-family: var(--font-display); font-size: 24px; color: var(--orange); letter-spacing: 3px; }
  .vendor-icon-btn { background: var(--surface2); border: 1px solid var(--border); border-radius: 50%; width: 40px; height: 40px; display: flex; align-items: center; justify-content: center; font-size: 18px; cursor: pointer; transition: all 0.2s; }
  .vendor-icon-btn:hover { border-color: var(--orange); }
  .vendor-truck-item { background: var(--surface); border: 1px solid var(--border); border-radius: var(--radius); margin: 0 20px 16px; overflow: hidden; transition: border-color 0.2s; }
  .vendor-truck-item.online { border-color: var(--green); }
  .vendor-truck-header { padding: 16px 20px; display: flex; align-items: center; gap: 14px; cursor: pointer; }
  .vendor-truck-emoji { font-size: 32px; }
  .vendor-truck-info { flex: 1; }
  .vendor-truck-name { font-family: var(--font-display); font-size: 22px; letter-spacing: 1px; color: var(--cream); line-height: 1; }
  .vendor-truck-cat { font-size: 12px; color: var(--muted); text-transform: uppercase; letter-spacing: 1.5px; margin-top: 2px; }
  .vendor-truck-chevron { color: var(--muted); font-size: 16px; transition: transform 0.2s; }
  .vendor-truck-chevron.open { transform: rotate(180deg); }
  .live-panel { border-top: 1px solid var(--border); padding: 20px; background: var(--surface2); animation: slideUp 0.25s ease; }
  .live-btn-row { display: flex; align-items: center; gap: 16px; margin-bottom: 16px; }
  .live-circle { width: 80px; height: 80px; border-radius: 50%; border: none; cursor: pointer; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 4px; transition: all 0.3s; flex-shrink: 0; }
  .live-circle.offline { background: radial-gradient(circle, #1e1e1e 0%, #141414 100%); border: 2.5px solid #2a2a2a; color: var(--muted); }
  .live-circle.offline:hover { border-color: var(--green); }
  .live-circle.online { background: radial-gradient(circle, #0d2e0d 0%, #071a07 100%); border: 2.5px solid var(--green); color: var(--green); animation: glow 2s ease-in-out infinite; }
  .live-circle.online:hover { animation: none; border-color: var(--red); background: radial-gradient(circle, #2e0d0d 0%, #1a0707 100%); color: var(--red); }
  .live-circle-icon { font-size: 28px; line-height: 1; }
  .live-circle-text { font-size: 9px; font-weight: 700; letter-spacing: 1px; text-transform: uppercase; }
  .live-info { flex: 1; }
  .live-info-title { font-family: var(--font-display); font-size: 18px; letter-spacing: 1px; color: var(--cream); margin-bottom: 4px; }
  .live-info-sub { font-size: 12px; color: var(--muted); line-height: 1.4; }
  .live-time-row { display: flex; align-items: center; gap: 10px; margin-bottom: 12px; }
  .live-time-label { font-size: 13px; color: var(--muted); white-space: nowrap; }
  .live-time-input { background: var(--bg); border: 1.5px solid var(--border); border-radius: var(--radius-sm); padding: 9px 12px; color: var(--cream); font-family: var(--font-body); font-size: 14px; outline: none; flex: 1; transition: border-color 0.2s; }
  .live-time-input:focus { border-color: var(--orange); }
  .analytics-grid { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 10px; margin-bottom: 16px; }
  .analytics-card { background: var(--surface2); border: 1px solid var(--border); border-radius: var(--radius-sm); padding: 14px 16px; }
  .analytics-value { font-family: var(--font-display); font-size: 32px; letter-spacing: 1px; color: var(--orange); line-height: 1; }
  .analytics-label { font-size: 11px; color: var(--muted); text-transform: uppercase; letter-spacing: 2px; margin-top: 4px; }
  .analytics-stars { color: #FFD700; font-size: 16px; }
  .comment-item { background: var(--surface2); border: 1px solid var(--border); border-radius: var(--radius-sm); padding: 12px 14px; margin-bottom: 8px; }
  .comment-rating { display: flex; gap: 2px; margin-bottom: 4px; }
  .comment-text { font-size: 13px; color: var(--cream); line-height: 1.4; }
  .add-truck-form { background: var(--surface2); border: 1.5px solid var(--orange); border-radius: var(--radius); padding: 20px; margin: 0 20px 16px; animation: slideUp 0.3s ease; }
  .add-truck-title { font-family: var(--font-display); font-size: 22px; letter-spacing: 1px; color: var(--orange); margin-bottom: 16px; }
  .app { min-height: 100vh; display: flex; flex-direction: column; background: var(--bg); animation: fadeIn 0.4s ease; }
  .topbar { background: var(--surface); border-bottom: 1px solid var(--border); padding: 14px 20px; display: flex; align-items: center; gap: 12px; position: sticky; top: 0; z-index: 100; }
  .topbar-logo { font-family: var(--font-display); font-size: 28px; color: var(--orange); letter-spacing: 3px; line-height: 1; }
  .search-wrap { flex: 1; position: relative; }
  .topbar-search { background: var(--surface2); border: 1.5px solid var(--border); border-radius: 24px; padding: 10px 16px 10px 40px; color: var(--cream); font-family: var(--font-body); font-size: 14px; outline: none; transition: border-color 0.2s; width: 100%; }
  .topbar-search:focus { border-color: var(--orange); }
  .topbar-search::placeholder { color: var(--muted); }
  .search-icon { position: absolute; left: 13px; top: 50%; transform: translateY(-50%); color: var(--muted); font-size: 15px; pointer-events: none; }
  .avatar-btn { width: 38px; height: 38px; border-radius: 50%; background: var(--orange); border: none; cursor: pointer; display: flex; align-items: center; justify-content: center; font-size: 18px; transition: transform 0.2s; flex-shrink: 0; }
  .avatar-btn:hover { transform: scale(1.1); }
  .assistant-banner { position: relative; background: linear-gradient(135deg,#1a0f06 0%,#1e1408 100%); border-bottom: 1px solid #2a1a0a; padding: 20px; }
  .assistant-close-btn { position: absolute; top: 14px; right: 14px; background: var(--surface); border: 1px solid var(--border); color: var(--muted); width: 26px; height: 26px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 13px; cursor: pointer; z-index: 2; }
  .assistant-close-btn:hover { color: var(--cream); border-color: var(--orange); }
  .assistant-row { display: flex; align-items: flex-start; gap: 14px; }
  .assistant-avatar { width: 44px; height: 44px; border-radius: 50%; background: var(--orange); display: flex; align-items: center; justify-content: center; font-size: 22px; flex-shrink: 0; box-shadow: 0 0 20px rgba(255,107,53,0.3); }
  .assistant-bubble { background: var(--surface2); border: 1px solid #2a1a0a; border-radius: 0 var(--radius) var(--radius) var(--radius); padding: 14px 16px; flex: 1; }
  .assistant-name { font-size: 11px; letter-spacing: 2px; text-transform: uppercase; color: var(--orange); font-weight: 600; margin-bottom: 4px; }
  .assistant-msg { font-size: 15px; color: var(--cream); line-height: 1.5; }
  .assistant-chips { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 12px; }
  .chip { background: var(--surface); border: 1.5px solid var(--border); border-radius: 20px; padding: 8px 14px; font-size: 13px; color: var(--cream); cursor: pointer; transition: all 0.2s; font-weight: 500; }
  .chip.active { background: var(--orange); border-color: var(--orange); color: white; }
  @media (hover: hover) { .chip:hover { background: var(--orange); border-color: var(--orange); color: white; } }
  .cat-strip { display: flex; gap: 8px; overflow-x: auto; padding: 16px 20px; scrollbar-width: none; }
  .cat-strip::-webkit-scrollbar { display: none; }
  .cat-pill { display: flex; align-items: center; gap: 6px; background: var(--surface); border: 1.5px solid var(--border); border-radius: 20px; padding: 8px 14px; white-space: nowrap; font-size: 13px; color: var(--cream); cursor: pointer; transition: all 0.2s; font-weight: 500; flex-shrink: 0; }
  .cat-pill.active { background: var(--orange); border-color: var(--orange); color: white; }
  @media (hover: hover) { .cat-pill:hover { background: var(--orange); border-color: var(--orange); color: white; } }
  .trucks-section { padding: 0 20px 100px; flex: 1; }
  .section-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px; padding-top: 16px; }
  .section-title { font-family: var(--font-display); font-size: 22px; letter-spacing: 1px; color: var(--cream); }
  .section-count { font-size: 13px; color: var(--muted); }
  .trucks-list { display: flex; flex-direction: column; gap: 14px; }
  .truck-card { background: var(--surface); border: 1px solid var(--border); border-radius: var(--radius); overflow: hidden; cursor: pointer; transition: all 0.25s; display: flex; position: relative; }
  .truck-card:hover { border-color: var(--orange); transform: translateY(-2px); box-shadow: 0 8px 30px rgba(0,0,0,0.4); }
  .truck-img { width: 110px; height: 110px; object-fit: cover; flex-shrink: 0; background: var(--surface2); display: flex; align-items: center; justify-content: center; font-size: 40px; }
  .truck-info { padding: 14px 14px 14px 16px; flex: 1; display: flex; flex-direction: column; gap: 4px; }
  .truck-name { font-family: var(--font-display); font-size: 20px; letter-spacing: 0.5px; color: var(--cream); line-height: 1; }
  .truck-cat { font-size: 12px; color: var(--muted); text-transform: uppercase; letter-spacing: 1.5px; }
  .truck-meta { display: flex; align-items: center; gap: 10px; margin-top: 4px; flex-wrap: wrap; }
  .badge-open { background: rgba(57,211,83,0.12); color: var(--green); border: 1px solid rgba(57,211,83,0.3); border-radius: 20px; padding: 3px 10px; font-size: 11px; font-weight: 700; letter-spacing: 1px; text-transform: uppercase; }
  .badge-closed { background: rgba(255,255,255,0.05); color: var(--muted); border: 1px solid var(--border); border-radius: 20px; padding: 3px 10px; font-size: 11px; letter-spacing: 1px; text-transform: uppercase; }
  .truck-distance { font-size: 12px; color: var(--muted); }
  .truck-rating { font-size: 13px; color: var(--cream); font-weight: 600; }
  .truck-favcount { font-size: 12px; color: var(--muted); display: inline-flex; align-items: center; gap: 3px; }
  .detail-favcount { font-size: 13px; color: var(--muted); margin-top: 4px; display: flex; align-items: center; gap: 4px; justify-content: flex-end; }
  .star { color: #FFD700; }
  .truck-fav { position: absolute; top: 10px; right: 10px; background: rgba(0,0,0,0.5); border: none; border-radius: 50%; width: 32px; height: 32px; font-size: 16px; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: transform 0.2s; }
  .truck-fav:hover { transform: scale(1.2); }
  .bottom-nav { background: var(--surface); border-top: 1px solid var(--border); padding: 12px 20px 20px; display: flex; justify-content: space-around; position: fixed; bottom: 0; left: 0; right: 0; z-index: 50; }
  .nav-item { display: flex; flex-direction: column; align-items: center; gap: 4px; background: none; border: none; cursor: pointer; padding: 6px 16px; border-radius: var(--radius-sm); transition: all 0.2s; color: var(--muted); font-family: var(--font-body); }
  .nav-item.active { color: var(--orange); }
  .nav-icon { font-size: 22px; }
  .nav-label { font-size: 11px; font-weight: 600; letter-spacing: 0.5px; text-transform: uppercase; }
  .detail { min-height: 100vh; background: var(--bg); animation: fadeIn 0.3s ease; padding-bottom: 80px; }
  .detail-hero { width: 100%; height: 240px; background: var(--surface2); display: flex; align-items: center; justify-content: center; font-size: 80px; }
  .detail-body { padding: 24px 20px; }
  .detail-header { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 16px; }
  .detail-name { font-family: var(--font-display); font-size: 42px; letter-spacing: 1px; line-height: 1; color: var(--cream); }
  .detail-actions { display: flex; gap: 10px; margin: 20px 0; }
  .action-btn { flex: 1; padding: 14px; border-radius: var(--radius-sm); border: 1.5px solid var(--border); background: var(--surface); color: var(--cream); font-size: 14px; font-weight: 600; cursor: pointer; transition: all 0.2s; display: flex; align-items: center; justify-content: center; gap: 6px; text-decoration: none; }
  .action-btn.primary { background: var(--orange); border-color: var(--orange); color: white; }
  .action-btn:hover { border-color: var(--orange); }
  .action-btn.primary:hover { background: #ff8558; }
  .schedule-item { background: var(--surface); border: 1px solid var(--border); border-radius: var(--radius-sm); padding: 14px 16px; margin-bottom: 10px; display: flex; gap: 12px; align-items: flex-start; }
  .schedule-days { font-size: 13px; font-weight: 700; color: var(--orange); text-transform: uppercase; letter-spacing: 1px; margin-bottom: 2px; }
  .schedule-time { font-size: 15px; color: var(--cream); font-weight: 600; }
  .schedule-addr { font-size: 13px; color: var(--muted); margin-top: 2px; }
  .review-item { background: var(--surface); border: 1px solid var(--border); border-radius: var(--radius-sm); padding: 14px 16px; margin-bottom: 10px; }
  .review-stars { display: flex; gap: 2px; margin-bottom: 6px; }
  .review-text { font-size: 14px; color: var(--cream); line-height: 1.5; }
  .section-label { font-size: 11px; letter-spacing: 3px; text-transform: uppercase; color: var(--orange); font-weight: 600; margin-bottom: 14px; margin-top: 28px; }
  .divider { height: 1px; background: var(--border); margin: 24px 0; }
  .review-form { background: var(--surface); border: 1px solid var(--border); border-radius: var(--radius); padding: 20px; margin-top: 8px; }
  .review-form-title { font-family: var(--font-display); font-size: 20px; letter-spacing: 1px; color: var(--cream); margin-bottom: 14px; }
  .star-selector { display: flex; gap: 6px; margin-bottom: 14px; }
  .star-btn { font-size: 30px; background: none; border: none; cursor: pointer; transition: transform 0.15s; line-height: 1; padding: 0; }
  .star-btn:hover { transform: scale(1.2); }
  .map-wrap { height: 280px; width: 100%; position: relative; z-index: 1; }
  .map-wrap .leaflet-container { height: 100%; width: 100%; background: #111; }
  .leaflet-tile { transition: filter 0.2s; }
  .map-wrap.map-dark .leaflet-tile { filter: invert(1) hue-rotate(180deg) brightness(0.82) saturate(0.5); }
  .map-toggle-btn { position: absolute; top: 12px; right: 12px; z-index: 1001; background: var(--surface); border: 1.5px solid var(--border); color: var(--cream); width: 38px; height: 38px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 17px; cursor: pointer; box-shadow: 0 4px 14px rgba(0,0,0,0.4); transition: all 0.2s; }
  .map-toggle-btn:hover { border-color: var(--orange); transform: scale(1.05); }
  .leaflet-control-zoom a { background: #1e1e1e !important; color: #f5f0eb !important; border-color: #2a2a2a !important; }
  .leaflet-control-attribution { background: rgba(0,0,0,0.7) !important; color: #444 !important; font-size: 10px !important; }
  .truck-popup .leaflet-popup-content-wrapper { background: #1e1e1e; border: 1px solid #333; border-radius: 14px; box-shadow: 0 8px 30px rgba(0,0,0,0.7); color: #f5f0eb; padding: 0; overflow: hidden; }
  .truck-popup .leaflet-popup-content { margin: 0; padding: 0; min-width: 180px; }
  .truck-popup .leaflet-popup-tip-container { display: none; }
  .truck-popup .leaflet-popup-close-button { color: #666 !important; font-size: 18px; top: 8px; right: 8px; }
  .empty-state { text-align: center; padding: 60px 20px; color: var(--muted); }
  .empty-state-icon { font-size: 48px; margin-bottom: 12px; opacity: 0.5; }
  .empty-state-text { font-size: 15px; line-height: 1.5; }
  .loading { display: flex; align-items: center; justify-content: center; padding: 60px 20px; color: var(--muted); font-size: 15px; gap: 10px; }
`;

const categoryEmoji = {
  Panini: "🍔",
  Pizza: "🍕",
  "Street Food": "🌮",
  Gelato: "🍦",
  Dolci: "🍰",
  Caffè: "☕",
  Fiori: "🌸",
  Abbigliamento: "👕",
  Casalinghi: "🧺",
  Birra: "🍺",
  Cocktail: "🍸",
  Pesce: "🐟",
  Carne: "🥩",
  Formaggi: "🧀",
  "Frutta e Verdura": "🍎",
  Altro: "📍",
};

const categories = [
  { label: "All", emoji: "✨" },
  { label: "Panini", emoji: "🍔" },
  { label: "Pizza", emoji: "🍕" },
  { label: "Street Food", emoji: "🌮" },
  { label: "Gelato", emoji: "🍦" },
  { label: "Dolci", emoji: "🍰" },
  { label: "Caffè", emoji: "☕" },
  { label: "Fiori", emoji: "🌸" },
  { label: "Abbigliamento", emoji: "👕" },
  { label: "Casalinghi", emoji: "🧺" },
  { label: "Birra", emoji: "🍺" },
  { label: "Cocktail", emoji: "🍸" },
  { label: "Pesce", emoji: "🐟" },
  { label: "Carne", emoji: "🥩" },
  { label: "Formaggi", emoji: "🧀" },
  { label: "Frutta e Verdura", emoji: "🍎" },
  { label: "Altro", emoji: "📍" },
];

const clientSteps = [
  {
    id: "mood",
    label: "Passo 1 di 3",
    question: "Cosa cerchi oggi?",
    hint: "Ti aiuto a trovare il venditore perfetto vicino a te.",
    options: [
      {
        emoji: "🍽️",
        label: "Mangiare qualcosa",
        sub: "Food truck e street food",
        value: "food",
      },
      {
        emoji: "🛍️",
        label: "Fare acquisti",
        sub: "Mercati e venditori",
        value: "market",
      },
      {
        emoji: "🎁",
        label: "Un regalo",
        sub: "Fiori, artigianato",
        value: "gift",
      },
      {
        emoji: "☕",
        label: "Bere qualcosa",
        sub: "Caffè, cocktail, birra",
        value: "drink",
      },
    ],
  },
  {
    id: "distance",
    label: "Passo 2 di 3",
    question: "Quanto sei disposto a camminare?",
    hint: "Filtro i venditori in base alla tua posizione.",
    options: [
      { emoji: "🚶", label: "Vicino vicino", sub: "< 500m", value: "near" },
      { emoji: "🗺️", label: "Nel quartiere", sub: "< 2km", value: "medium" },
      { emoji: "🚲", label: "Anche in bici", sub: "< 5km", value: "far" },
      {
        emoji: "🚗",
        label: "In macchina",
        sub: "Qualsiasi distanza",
        value: "any",
      },
    ],
  },
  {
    id: "now",
    label: "Passo 3 di 3",
    question: "Quando vuoi andare?",
    hint: "Ti mostro solo chi è disponibile nel momento giusto.",
    cols: 1,
    options: [
      { emoji: "⚡", label: "Adesso!", sub: "Solo aperti ora", value: "now" },
      {
        emoji: "🌅",
        label: "Oggi più tardi",
        sub: "Nelle prossime ore",
        value: "later",
      },
      {
        emoji: "📅",
        label: "Nei prossimi giorni",
        sub: "Vedo tutti",
        value: "week",
      },
    ],
  },
];

const createEmojiIcon = (emoji, isOpen) =>
  L.divIcon({
    html: `<div style="font-size:26px;background:${
      isOpen ? "#ff6b35" : "#1e1e1e"
    };border:2px solid ${
      isOpen ? "#ff8558" : "#333"
    };border-radius:50% 50% 50% 0;width:42px;height:42px;display:flex;align-items:center;justify-content:center;transform:rotate(-45deg);box-shadow:0 4px 14px rgba(0,0,0,0.5);"><span style="transform:rotate(45deg);display:block;">${emoji}</span></div>`,
    className: "",
    iconSize: [42, 42],
    iconAnchor: [21, 42],
    popupAnchor: [0, -44],
  });
function resizeImage(file, maxDim = 1600, quality = 0.82) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        let { width, height } = img;
        if (width > maxDim || height > maxDim) {
          if (width > height) {
            height = Math.round((height * maxDim) / width);
            width = maxDim;
          } else {
            width = Math.round((width * maxDim) / height);
            height = maxDim;
          }
        }
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);
        canvas.toBlob(
          (blob) => (blob ? resolve(blob) : reject(new Error("Compressione fallita"))),
          "image/jpeg",
          quality
        );
      };
      img.onerror = reject;
      img.src = e.target.result;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

function ImageUploader({ vendorId, currentImage, onUploaded }) {
  const [uploading, setUploading] = useState(false);
  const [preview, setPreview] = useState(currentImage || "");
  const [error, setError] = useState("");

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) {
      setError("Seleziona un file immagine.");
      return;
    }
    if (file.size > 15 * 1024 * 1024) {
      setError("L'immagine deve essere sotto i 15MB.");
      return;
    }
    setError("");
    setPreview(URL.createObjectURL(file));
    setUploading(true);
    try {
      const resized = await resizeImage(file);
      const storageRef = ref(storage, `vendors/${vendorId}/main.jpg`);
      await uploadBytes(storageRef, resized);
      const url = await getDownloadURL(storageRef);
      onUploaded(url);
    } catch (err) {
      console.error(err);
      setError("Errore durante l'upload. Riprova.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div style={{ marginBottom: 12 }}>
      {preview && (
        <img
          src={preview}
          alt="Anteprima"
          style={{
            width: "100%",
            height: 160,
            objectFit: "cover",
            borderRadius: "var(--radius-sm)",
            marginBottom: 8,
            border: "1px solid var(--border)",
          }}
        />
      )}
      <label
        style={{
          display: "block",
          textAlign: "center",
          padding: "12px",
          borderRadius: "var(--radius-sm)",
          border: "1.5px dashed var(--border)",
          color: "var(--muted)",
          fontSize: 13,
          fontWeight: 600,
          cursor: uploading ? "not-allowed" : "pointer",
          opacity: uploading ? 0.6 : 1,
        }}
      >
        {uploading
          ? "⏳ Caricamento..."
          : preview
          ? "📷 Cambia foto"
          : "📷 Carica foto"}
        <input
          type="file"
          accept="image/*"
          onChange={handleFileChange}
          disabled={uploading}
          style={{ display: "none" }}
        />
      </label>
      {error && (
        <div className="error-msg" style={{ marginTop: 8 }}>
          {error}
        </div>
      )}
    </div>
  );
}

function GalleryUploader({ vendorId, images, onUpdate }) {
  const MAX_IMAGES = 6;
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState("");

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) { setError("Seleziona un file immagine."); return; }
    if (file.size > 15 * 1024 * 1024) { setError("L'immagine deve essere sotto i 15MB."); return; }
    if (images.length >= MAX_IMAGES) { setError(`Massimo ${MAX_IMAGES} foto.`); return; }
    setError("");
    setUploading(true);
    try {
      const resized = await resizeImage(file);
      const storageRef = ref(storage, `vendors/${vendorId}/gallery/${Date.now()}.jpg`);
      await uploadBytes(storageRef, resized);
      const url = await getDownloadURL(storageRef);
      await onUpdate([...images, url]);
    } catch (err) {
      console.error(err);
      setError("Errore durante l'upload. Riprova.");
    } finally {
      setUploading(false);
    }
  };

  const removeImage = async (url) => {
    await onUpdate(images.filter((i) => i !== url));
  };

  return (
    <div style={{ marginBottom: 12 }}>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 8, marginBottom: 10 }}>
        {images.map((url, i) => (
          <div key={url} style={{ position: "relative", aspectRatio: "1", borderRadius: "var(--radius-sm)", overflow: "hidden", border: "1px solid var(--border)" }}>
            <img src={url} alt={`Foto ${i + 1}`} style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
            <button
              onClick={() => removeImage(url)}
              style={{ position: "absolute", top: 4, right: 4, background: "rgba(0,0,0,0.6)", border: "none", color: "white", width: 22, height: 22, borderRadius: "50%", fontSize: 12, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}
            >
              ✕
            </button>
          </div>
        ))}
        {images.length < MAX_IMAGES && (
          <label
            style={{ aspectRatio: "1", borderRadius: "var(--radius-sm)", border: "1.5px dashed var(--border)", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 4, color: "var(--muted)", fontSize: 12, fontWeight: 600, cursor: uploading ? "not-allowed" : "pointer", opacity: uploading ? 0.6 : 1, textAlign: "center" }}
          >
            <span style={{ fontSize: 20 }}>+</span>
            {uploading ? "..." : "Aggiungi"}
            <input type="file" accept="image/*" onChange={handleFileChange} disabled={uploading} style={{ display: "none" }} />
          </label>
        )}
      </div>
      <div style={{ fontSize: 12, color: "var(--muted)" }}>{images.length}/{MAX_IMAGES} foto</div>
      {error && <div className="error-msg" style={{ marginTop: 8 }}>{error}</div>}
    </div>
  );
}

function TruckHeroGallery({ vendor }) {
  const images = vendor.images && vendor.images.length > 0 ? vendor.images : (vendor.image ? [vendor.image] : []);
  if (images.length === 0) {
    return (
      <div className="detail-hero" style={{ fontSize: 100 }}>
        {categoryEmoji[vendor.category] || "📍"}
      </div>
    );
  }
  return (
    <div style={{ display: "flex", overflowX: "auto", scrollSnapType: "x mandatory", height: 240 }}>
      {images.map((url, i) => (
        <img
          key={i}
          src={url}
          alt={`${vendor.name} ${i + 1}`}
          style={{ width: "100%", height: 240, objectFit: "cover", flexShrink: 0, scrollSnapAlign: "start" }}
        />
      ))}
    </div>
  );
}

function RecenterMap({ position }) {
  const map = useMap();
  useEffect(() => {
    if (position) map.setView(position, 14, { animate: true });
  }, [position]);
  return null;
}

const TruckyMap = React.memo(function TruckyMap({ vendors, onOpenTruck, userPosition }) {
  const center = userPosition || [45.6495, 13.7768];
  const [darkMap, setDarkMap] = useState(() => {
    try { return localStorage.getItem("tuk_map_theme") !== "light"; } catch { return true; }
  });
  useEffect(() => {
    try { localStorage.setItem("tuk_map_theme", darkMap ? "dark" : "light"); } catch {}
  }, [darkMap]);
  return (
    <div className={`map-wrap ${darkMap ? "map-dark" : ""}`}>
      <button
        className="map-toggle-btn"
        onClick={() => setDarkMap((d) => !d)}
        title={darkMap ? "Passa a mappa chiara" : "Passa a mappa scura"}
      >
        {darkMap ? "☀️" : "🌙"}
      </button>
      <MapContainer
        key="tuk-map"
        center={center}
        zoom={14}
        scrollWheelZoom={false}
        style={{ height: "100%", width: "100%" }}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution="© OpenStreetMap"
        />
        <RecenterMap position={userPosition} />
        {userPosition && (
          <Marker
            position={userPosition}
            icon={L.divIcon({
              html: `<div style="width:16px;height:16px;background:#ff6b35;border-radius:50%;border:3px solid white;box-shadow:0 0 0 3px rgba(255,107,53,0.3);"></div>`,
              className: "",
              iconSize: [16, 16],
              iconAnchor: [8, 8],
            })}
          >
            <Popup className="truck-popup">
              <div
                style={{
                  padding: "12px 14px",
                  textAlign: "center",
                  color: "#f5f0eb",
                  fontSize: 13,
                }}
              >
                📍 Sei qui
              </div>
            </Popup>
          </Marker>
        )}
        {vendors
          .filter((v) => v.lat != null && v.lng != null && (!v.isAdditionalTruck || v.isPremium))
          .map((v) => (
            <Marker
              key={v.id}
              position={[v.lat, v.lng]}
              icon={createEmojiIcon(
                categoryEmoji[v.category] || "📍",
                v.isOpenNow
              )}
            >
              <Popup className="truck-popup">
                <div style={{ padding: "14px 16px" }}>
                  <div
                    style={{
                      fontSize: 11,
                      letterSpacing: 2,
                      textTransform: "uppercase",
                      color: "#ff6b35",
                      fontWeight: 700,
                      marginBottom: 3,
                    }}
                  >
                    {v.category}
                  </div>
                  <div
                    style={{
                      fontFamily: "'Bebas Neue',sans-serif",
                      fontSize: 22,
                      letterSpacing: 1,
                      color: "#f5f0eb",
                      marginBottom: 6,
                    }}
                  >
                    {v.name}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                      marginBottom: 10,
                    }}
                  >
                    {v.isOpenNow ? (
                      <span
                        style={{
                          background: "rgba(57,211,83,0.15)",
                          color: "#39d353",
                          border: "1px solid rgba(57,211,83,0.3)",
                          borderRadius: 20,
                          padding: "2px 10px",
                          fontSize: 11,
                          fontWeight: 700,
                        }}
                      >
                        ● APERTO
                      </span>
                    ) : (
                      <span
                        style={{
                          background: "rgba(255,255,255,0.05)",
                          color: "#666",
                          border: "1px solid #2a2a2a",
                          borderRadius: 20,
                          padding: "2px 10px",
                          fontSize: 11,
                        }}
                      >
                        CHIUSO
                      </span>
                    )}
                  </div>
                  <button
                    onClick={() => onOpenTruck(v)}
                    style={{
                      width: "100%",
                      background: "#ff6b35",
                      color: "white",
                      border: "none",
                      borderRadius: 10,
                      padding: "9px 0",
                      fontSize: 13,
                      fontWeight: 700,
                      cursor: "pointer",
                    }}
                  >
                    Apri scheda →
                  </button>
                </div>
              </Popup>
            </Marker>
          ))}
      </MapContainer>
    </div>
  );
});

function AuthSheet({ onClose, onSuccess }) {
  const [tab, setTab] = useState("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("client");
  const [vatNumber, setVatNumber] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [resetSent, setResetSent] = useState(false);
  const [showReset, setShowReset] = useState(false);
  const [resetEmail, setResetEmail] = useState("");
  const [resetLoading, setResetLoading] = useState(false);

  const handleLogin = async () => {
    setError("");
    setLoading(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
      onSuccess("login");
    } catch {
      setError("Email o password errati.");
    } finally {
      setLoading(false);
    }
  };

  const handleRegister = async () => {
    setError("");
    if (!email || !password) {
      setError("Inserisci email e password.");
      return;
    }
    if (password.length < 6) {
      setError("Password di almeno 6 caratteri.");
      return;
    }
    if (role === "vendor") {
      if (!vatNumber) {
        setError("Inserisci la P.IVA.");
        return;
      }
      if (!isValidPartitaIva(vatNumber)) {
        setError("La P.IVA inserita non e' valida. Controlla le 11 cifre.");
        return;
      }
      try {
        const verificaPiva = httpsCallable(functionsInstance, "verificaPartitaIva");
        const result = await verificaPiva({ piva: vatNumber });
        if (!result.data.valid) {
          setError("La P.IVA inserita non risulta attiva. Verifica il numero inserito.");
          return;
        }
      } catch (e) {
        console.log("Verifica P.IVA non disponibile:", e);
      }
    }
    setLoading(true);
    try {
      const res = await createUserWithEmailAndPassword(auth, email, password);
      await setDoc(doc(db, "users", res.user.uid), {
        uid: res.user.uid,
        email: res.user.email,
        role,
        vatNumber: role === "vendor" ? vatNumber : "",
        onboardingCompleted: false,
      });
      try {
        await sendEmailVerification(res.user);
      } catch (e) {
        console.log("Invio email di verifica non riuscito:", e);
      }
      onSuccess("register", role);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleResetPassword = async () => {
    if (!resetEmail) {
      setError("Inserisci la tua email.");
      return;
    }
    setResetLoading(true);
    try {
      await sendPasswordResetEmail(auth, resetEmail);
      setResetSent(true);
      setError("");
    } catch (err) {
      setError("Email non trovata. Controlla l'indirizzo inserito.");
    } finally {
      setResetLoading(false);
    }
  };

  if (showReset)
    return (
      <>
        <div className="sheet-overlay" onClick={onClose} />
        <div className="sheet">
          <div className="sheet-handle" />
          <button
            className="btn-ghost"
            style={{ marginBottom: 8, padding: 0 }}
            onClick={() => {
              setShowReset(false);
              setResetSent(false);
              setError("");
            }}
          >
            ← Torna al login
          </button>
          <div className="sheet-title">RESET PASSWORD</div>
          <div className="sheet-sub">
            Ti mandiamo un link per reimpostare la password.
          </div>
          {resetSent ? (
            <div
              style={{
                background: "rgba(57,211,83,0.1)",
                border: "1px solid rgba(57,211,83,0.3)",
                borderRadius: "var(--radius-sm)",
                padding: "16px",
                textAlign: "center",
              }}
            >
              <div style={{ fontSize: 32, marginBottom: 8 }}>✅</div>
              <div
                style={{
                  color: "var(--green)",
                  fontWeight: 600,
                  marginBottom: 4,
                }}
              >
                Email inviata!
              </div>
              <div style={{ fontSize: 13, color: "var(--muted)" }}>
                Controlla la tua casella di posta e segui le istruzioni.
              </div>
              <button
                className="btn-primary"
                style={{ marginTop: 16, fontSize: 16 }}
                onClick={() => {
                  setShowReset(false);
                  setResetSent(false);
                }}
              >
                Torna al login
              </button>
            </div>
          ) : (
            <>
              {error && <div className="error-msg">{error}</div>}
              <input
                className="input-field"
                placeholder="La tua email"
                type="email"
                value={resetEmail}
                onChange={(e) => setResetEmail(e.target.value)}
              />
              <button
                className="btn-primary"
                style={{ fontSize: 18 }}
                disabled={resetLoading}
                onClick={handleResetPassword}
              >
                {resetLoading ? "..." : "INVIA LINK RESET"}
              </button>
            </>
          )}
        </div>
      </>
    );

  return (
    <>
      <div className="sheet-overlay" onClick={onClose} />
      <div className="sheet">
        <div className="sheet-handle" />
        <div className="sheet-title">
          {tab === "login" ? "BENTORNATO" : "REGISTRATI"}
        </div>
        <div className="sheet-sub">
          {tab === "login"
            ? "Accedi al tuo account Tuk."
            : "Crea il tuo account in pochi secondi."}
        </div>
        <div className="sheet-tabs">
          <button
            className={`sheet-tab ${tab === "login" ? "active" : ""}`}
            onClick={() => {
              setTab("login");
              setError("");
            }}
          >
            Accedi
          </button>
          <button
            className={`sheet-tab ${tab === "register" ? "active" : ""}`}
            onClick={() => {
              setTab("register");
              setError("");
            }}
          >
            Registrati
          </button>
        </div>
        {tab === "register" && (
          <div className="role-row">
            <div
              className={`role-pill ${role === "client" ? "active" : ""}`}
              onClick={() => setRole("client")}
            >
              🧑 Cliente
            </div>
            <div
              className={`role-pill ${role === "vendor" ? "active" : ""}`}
              onClick={() => setRole("vendor")}
            >
              🚚 Venditore
            </div>
          </div>
        )}
        {error && <div className="error-msg">{error}</div>}
        <input
          className="input-field"
          placeholder="Email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          className="input-field"
          placeholder="Password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        {tab === "register" && role === "vendor" && (
          <input
            className="input-field"
            placeholder="P.IVA"
            value={vatNumber}
            onChange={(e) => setVatNumber(e.target.value)}
          />
        )}
        <button
          className="btn-primary"
          disabled={loading}
          onClick={tab === "login" ? handleLogin : handleRegister}
          style={{ marginTop: 8 }}
        >
          {loading ? "..." : tab === "login" ? "ACCEDI" : "CREA ACCOUNT"}
        </button>
        {tab === "login" && (
          <button
            className="btn-ghost"
            style={{ marginTop: 12, width: "100%", textAlign: "center" }}
            onClick={() => {
              setShowReset(true);
              setResetEmail(email);
              setError("");
            }}
          >
            Password dimenticata?
          </button>
        )}
      </div>
    </>
  );
}

function VendorOnboarding({ user, onComplete }) {
  const [step, setStep] = useState(0);
  const [saving, setSaving] = useState(false);
  const [profile, setProfile] = useState({
    name: "",
    category: "Panini",
    phone: "",
    instagram: "",
    description: "",
    image: "",
  });
  const [schedule, setSchedule] = useState({
    days: [],
    start: "",
    end: "",
    address: "",
  });
  const [geocoding, setGeocoding] = useState(false);
  const weekDays = ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"];
  const toggleDay = (d) =>
    setSchedule((prev) => ({
      ...prev,
      days: prev.days.includes(d)
        ? prev.days.filter((x) => x !== d)
        : [...prev.days, d],
    }));

  const completeOnboarding = async (skipSchedule = false) => {
    setSaving(true);
    try {
      let scheduleEntry = [];
      if (
        !skipSchedule &&
        schedule.address &&
        schedule.days.length &&
        schedule.start &&
        schedule.end
      ) {
        setGeocoding(true);
        try {
          const res = await fetch(
            `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(
              schedule.address
            )}&limit=1`,
            { headers: { "Accept-Language": "it" } }
          );
          const data = await res.json();
          if (data.length)
            scheduleEntry = [
              {
                ...schedule,
                lat: parseFloat(data[0].lat),
                lng: parseFloat(data[0].lon),
              },
            ];
        } catch {}
        setGeocoding(false);
      }
      await addDoc(collection(db, "vendors"), {
        ...profile,
        userId: user.uid,
        isOpenNow: false,
        lat: null,
        lng: null,
        schedule: scheduleEntry,
        createdAt: new Date(),
      });
      await updateDoc(doc(db, "users", user.uid), {
        onboardingCompleted: true,
      });
      onComplete();
    } catch (e) {
      alert(e.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="onboarding">
      <div className="onboarding-header">
        <div
          style={{
            fontFamily: "var(--font-display)",
            fontSize: 20,
            color: "var(--orange)",
            letterSpacing: 2,
            flex: 1,
          }}
        >
          TUK
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          {[0, 1].map((i) => (
            <div
              key={i}
              className={`onboarding-step-dot ${
                i === step ? "active" : i < step ? "done" : ""
              }`}
            />
          ))}
        </div>
      </div>
      {step === 0 && (
        <div className="onboarding-body">
          <div
            style={{
              fontSize: 12,
              letterSpacing: 3,
              textTransform: "uppercase",
              color: "var(--orange)",
              fontWeight: 600,
              marginBottom: 8,
            }}
          >
            Passo 1 di 2
          </div>
          <div className="onboarding-title">
            CIAO! 👋
            <br />
            RACCONTACI DI TE
          </div>
          <div className="onboarding-sub">
            Inserisci le info del tuo primo truck.
          </div>
          <div className="section-mini-label">Nome del truck *</div>
          <input
            className="input-field"
            placeholder="Es: Burgher King..."
            value={profile.name}
            onChange={(e) => setProfile({ ...profile, name: e.target.value })}
          />
          <div className="section-mini-label">Cosa vendi?</div>
          <select
            className="input-field"
            value={profile.category}
            onChange={(e) =>
              setProfile({ ...profile, category: e.target.value })
            }
            style={{ cursor: "pointer" }}
          >
            {Object.keys(categoryEmoji).map((c) => (
              <option key={c}>{c}</option>
            ))}
          </select>
          <div className="section-mini-label">Foto</div>
          <ImageUploader
            vendorId={user.uid}
            currentImage={profile.image}
            onUploaded={(url) => setProfile({ ...profile, image: url })}
          />

          <div className="section-mini-label">Contatti</div>
          <input
            className="input-field"
            placeholder="Telefono"
            value={profile.phone}
            onChange={(e) => setProfile({ ...profile, phone: e.target.value })}
          />
          <input
            className="input-field"
            placeholder="Instagram (senza @)"
            value={profile.instagram}
            onChange={(e) =>
              setProfile({ ...profile, instagram: e.target.value })
            }
          />
          <div className="section-mini-label">Descrizione</div>
          <textarea
            className="input-field"
            placeholder="Raccontati in poche parole..."
            rows={3}
            style={{ resize: "none" }}
            value={profile.description}
            onChange={(e) =>
              setProfile({ ...profile, description: e.target.value })
            }
          />
          <button
            className="btn-primary"
            style={{ marginTop: 16, fontSize: 18 }}
            onClick={() => {
              if (!profile.name) {
                alert("Inserisci il nome");
                return;
              }
              setStep(1);
            }}
          >
            AVANTI →
          </button>
        </div>
      )}
      {step === 1 && (
        <div className="onboarding-body">
          <div
            style={{
              fontSize: 12,
              letterSpacing: 3,
              textTransform: "uppercase",
              color: "var(--orange)",
              fontWeight: 600,
              marginBottom: 8,
            }}
          >
            Passo 2 di 2
          </div>
          <div className="onboarding-title">
            DOVE SEI
            <br />
            DI SOLITO? 📍
          </div>
          <div className="onboarding-sub">
            Prima fascia oraria. Puoi saltare e farlo dopo.
          </div>
          <div className="section-mini-label">Giorni</div>
          <div
            style={{
              display: "flex",
              gap: 6,
              flexWrap: "wrap",
              marginBottom: 16,
            }}
          >
            {weekDays.map((d) => (
              <button
                key={d}
                onClick={() => toggleDay(d)}
                style={{
                  padding: "9px 13px",
                  borderRadius: 8,
                  border: "1.5px solid",
                  borderColor: schedule.days.includes(d)
                    ? "var(--orange)"
                    : "var(--border)",
                  background: schedule.days.includes(d)
                    ? "rgba(255,107,53,0.15)"
                    : "var(--surface)",
                  color: schedule.days.includes(d)
                    ? "var(--orange)"
                    : "var(--muted)",
                  fontWeight: 700,
                  fontSize: 13,
                  cursor: "pointer",
                }}
              >
                {d}
              </button>
            ))}
          </div>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 10,
              marginBottom: 4,
            }}
          >
            <div>
              <div className="section-mini-label" style={{ marginTop: 0 }}>
                Dalle
              </div>
              <input
                type="time"
                className="time-input"
                style={{ marginBottom: 0 }}
                value={schedule.start}
                onChange={(e) =>
                  setSchedule({ ...schedule, start: e.target.value })
                }
              />
            </div>
            <div>
              <div className="section-mini-label" style={{ marginTop: 0 }}>
                Alle
              </div>
              <input
                type="time"
                className="time-input"
                style={{ marginBottom: 0 }}
                value={schedule.end}
                onChange={(e) =>
                  setSchedule({ ...schedule, end: e.target.value })
                }
              />
            </div>
          </div>
          <div className="section-mini-label">Indirizzo</div>
          <input
            className="input-field"
            placeholder="Es: Piazza Unità, Trieste"
            value={schedule.address}
            onChange={(e) =>
              setSchedule({ ...schedule, address: e.target.value })
            }
          />
          <button
            className="btn-primary"
            style={{ marginTop: 16, fontSize: 18 }}
            disabled={saving || geocoding}
            onClick={() => completeOnboarding(false)}
          >
            {saving || geocoding ? "⏳ Salvataggio..." : "🚀 INIZIA CON TUK"}
          </button>
          <button
            className="btn-ghost"
            style={{ marginTop: 12, width: "100%", textAlign: "center" }}
            onClick={() => completeOnboarding(true)}
          >
            Salta per ora →
          </button>
        </div>
      )}
    </div>
  );
}

function TruckAnalytics({ truck, reviews }) {
  const truckReviews = reviews.filter((r) => r.vendorId === truck.id);
  const avg = truckReviews.length
    ? (
        truckReviews.reduce((a, b) => a + b.rating, 0) / truckReviews.length
      ).toFixed(1)
    : null;
  const last3 = [...truckReviews].reverse().slice(0, 3);
  const [couponCount, setCouponCount] = useState(0);
  useEffect(() => {
    getDocs(query(collection(db, "coupons"), where("vendorId", "==", truck.id), where("usato", "==", true)))
      .then(snap => setCouponCount(snap.size));
  }, [truck.id]);
  return (
    <div style={{ padding: "16px 20px 8px" }}>
      <div
        style={{
          fontSize: 11,
          letterSpacing: 3,
          textTransform: "uppercase",
          color: "var(--orange)",
          fontWeight: 600,
          marginBottom: 12,
        }}
      >
        Analytics
      </div>
      <div className="analytics-grid">
        <div className="analytics-card">
          <div className="analytics-value">{avg || "–"}</div>
          <div className="analytics-stars">
            {"★".repeat(Math.round(avg || 0))}
          </div>
          <div className="analytics-label">Media stelle</div>
        </div>
        <div className="analytics-card">
          <div className="analytics-value">{truckReviews.length}</div>
          <div className="analytics-label">Recensioni</div>
        </div>

        <div className="analytics-card">
          <div className="analytics-value">{truck.isOpenNow ? "🟢" : "⚫"}</div>
          <div className="analytics-label">
            {truck.isOpenNow ? "Online ora" : "Offline"}
          </div>
        </div>
        <div className="analytics-card">
          <div className="analytics-value">{couponCount}</div>
          <div className="analytics-label">Coupon usati</div>
        </div>
      </div>
      {last3.length > 0 && (
        <>
          <div
            style={{
              fontSize: 11,
              letterSpacing: 3,
              textTransform: "uppercase",
              color: "var(--orange)",
              fontWeight: 600,
              marginBottom: 10,
            }}
          >
            Ultimi commenti
          </div>
          {last3.map((r) => (
            <div key={r.id} className="comment-item">
              <div className="comment-rating">
                {[1, 2, 3, 4, 5].map((i) => (
                  <span
                    key={i}
                    style={{
                      color: i <= r.rating ? "#FFD700" : "var(--border)",
                      fontSize: 12,
                    }}
                  >
                    ★
                  </span>
                ))}
              </div>
              <div className="comment-text">{r.comment}</div>
            </div>
          ))}
        </>
      )}
    </div>
  );
}

function VendorHome({ user, myTrucks, reviews, onOpenSettings }) {
  const [expandedId, setExpandedId] = useState(null);
  const [liveUntil, setLiveUntil] = useState({});
  const [toggling, setToggling] = useState({});
  const [activePanel, setActivePanel] = useState({});
  const [showAddForm, setShowAddForm] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [newTruck, setNewTruck] = useState({
    name: "",
    category: "Panini",
    phone: "",
    instagram: "",
    description: "",
    image: "",
  });
  const [saving, setSaving] = useState(false);

  const toggleExpand = (id) => {
    setExpandedId((prev) => (prev === id ? null : id));
    setActivePanel((prev) => ({ ...prev, [id]: prev[id] || "live" }));
  };

  const toggleLive = async (truck) => {
    setToggling((prev) => ({ ...prev, [truck.id]: true }));
    try {
      if (!truck.isOpenNow) {
        const until = liveUntil[truck.id] || "20:00";
        navigator.geolocation.getCurrentPosition(
          async (pos) => {
            await updateDoc(doc(db, "vendors", truck.id), {
              lat: pos.coords.latitude,
              lng: pos.coords.longitude,
              isOpenNow: true,
              liveUntil: until,
              lastUpdated: new Date(),
            });
            setToggling((prev) => ({ ...prev, [truck.id]: false }));
          },
          async () => {
            // Geolocalizzazione fallita (comune su iPhone con l'app
            // aggiunta alla schermata Home): se abbiamo già una posizione
            // salvata in precedenza la riusiamo, così il truck resta
            // visibile sulla mappa. Altrimenti avvisiamo il venditore
            // invece di metterlo "online" ma invisibile a tutti.
            if (truck.lat != null && truck.lng != null) {
              await updateDoc(doc(db, "vendors", truck.id), {
                isOpenNow: true,
                liveUntil: until,
                lastUpdated: new Date(),
              });
            } else {
              alert(
                "Non riesco ad attivare la tua posizione, quindi non comparirai sulla mappa. Su iPhone: Impostazioni > Privacy e sicurezza > Localizzazione, assicurati sia attiva, poi vai su Impostazioni > Safari > Posizione e consenti l'accesso. Poi riprova."
              );
            }
            setToggling((prev) => ({ ...prev, [truck.id]: false }));
          },
          { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
        );
      } else {
        await updateDoc(doc(db, "vendors", truck.id), {
          isOpenNow: false,
          liveUntil: "",
          lastUpdated: new Date(),
        });
        setToggling((prev) => ({ ...prev, [truck.id]: false }));
      }
    } catch (e) {
      alert(e.message);
      setToggling((prev) => ({ ...prev, [truck.id]: false }));
    }
  };

  const handleAddTruck = async () => {
    if (!newTruck.name) {
      alert("Inserisci il nome del truck");
      return;
    }
    setSaving(true);
    try {
      await addDoc(collection(db, "vendors"), {
        ...newTruck,
        userId: user.uid,
        isOpenNow: false,
        lat: null,
        lng: null,
        schedule: [],
        isAdditionalTruck: myTrucks.length > 0,
        createdAt: new Date(),
      });
      setNewTruck({
        name: "",
        category: "Panini",
        phone: "",
        instagram: "",
        description: "",
        image: "",
      });
      setShowAddForm(false);
      alert("✅ Nuovo truck aggiunto!");
    } catch (e) {
      alert(e.message);
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (truck) => {
    if (
      !window.confirm(
        `Eliminare "${truck.name}"? Questa azione non può essere annullata.`
      )
    )
      return;
    try {
      await deleteDoc(doc(db, "vendors", truck.id));
    } catch (e) {
      alert(e.message);
    }
  };

  const onlineCount = myTrucks.filter((t) => t.isOpenNow).length;

  return (
    <div className="vendor-home">
      {showSettings && (
        <>
          <div className="sheet-overlay" onClick={() => setShowSettings(false)} />
          <div className="sheet">
            <div className="sheet-handle" />
            <div className="sheet-title">IMPOSTAZIONI</div>
            <div style={{marginTop:24,display:"flex",flexDirection:"column",gap:16}}>
              <a href="https://trucky-96c2f.web.app/privacy.html" target="_blank" rel="noreferrer" style={{color:"var(--muted)",fontSize:15,textDecoration:"none",padding:"14px 0",borderBottom:"1px solid var(--border)"}}>🔒 Privacy Policy</a>
              <a href="https://trucky-96c2f.web.app/termini.html" target="_blank" rel="noreferrer" style={{color:"var(--muted)",fontSize:15,textDecoration:"none",padding:"14px 0",borderBottom:"1px solid var(--border)"}}>📄 Termini e Condizioni</a>
              <a href="https://trucky-96c2f.web.app/rimborsi.html" target="_blank" rel="noreferrer" style={{color:"var(--muted)",fontSize:15,textDecoration:"none",padding:"14px 0",borderBottom:"1px solid var(--border)"}}>💳 Politica di Rimborso</a>
              <a href="https://trucky-96c2f.web.app/prezzi.html" target="_blank" rel="noreferrer" style={{color:"var(--muted)",fontSize:15,textDecoration:"none",padding:"14px 0",borderBottom:"1px solid var(--border)"}}>💰 Prezzi Premium</a>
              <button onClick={() => { signOut(auth); }} style={{background:"transparent",border:"none",color:"var(--red)",fontSize:15,textAlign:"left",padding:"14px 0",cursor:"pointer"}}>🚪 Esci dall'account</button>
            </div>
          </div>
        </>
      )}
      <div className="vendor-home-header">
        <div>
          <div className="vendor-home-logo" style={{display:"flex",alignItems:"center",gap:8}}>
            <img src="/logo-header.png" alt="Tuk" style={{width:28,height:28,borderRadius:6,objectFit:"cover"}} />
            TUK
          </div>
          <div style={{ fontSize: 12, color: "var(--muted)", marginTop: 2 }}>
            {myTrucks.length} truck · {onlineCount} online
          </div>
        </div>
        <div style={{ display: "flex", gap: 10 }}>
          <button
            className="vendor-icon-btn"
            onClick={() => setShowSettings(true)}
            title="Impostazioni"
          >
            ⚙️
          </button>
          <button
            className="vendor-icon-btn"
            onClick={() => signOut(auth)}
            title="Esci"
            style={{ fontSize: 16 }}
          >
            🚪
          </button>
        </div>
      </div>
      <div style={{ paddingTop: 20, paddingBottom: 100 }}>
        {myTrucks.length === 0 && !showAddForm && (
          <div className="empty-state">
            <div className="empty-state-icon">🚚</div>
            <div className="empty-state-text">
              Nessun truck ancora.
              <br />
              Aggiungine uno!
            </div>
          </div>
        )}
        {myTrucks.map((truck) => {
          const isExpanded = expandedId === truck.id;
          const panel = activePanel[truck.id] || "live";
          const until = liveUntil[truck.id] || "20:00";
          const isToggling = toggling[truck.id] || false;
          return (
            <div
              key={truck.id}
              className={`vendor-truck-item ${truck.isOpenNow ? "online" : ""}`}
            >
              <div
                className="vendor-truck-header"
                onClick={() => toggleExpand(truck.id)}
              >
                <div className="vendor-truck-emoji">
                  {categoryEmoji[truck.category] || "📍"}
                </div>
                <div className="vendor-truck-info">
                  <div className="vendor-truck-name">{truck.name}</div>
                  <div className="vendor-truck-cat">
                    {truck.category} ·{" "}
                    {truck.isOpenNow
                      ? `🟢 Online fino alle ${truck.liveUntil}`
                      : "⚫ Offline"}
                  </div>
                </div>
                <div
                  className={`vendor-truck-chevron ${isExpanded ? "open" : ""}`}
                >
                  ▼
                </div>
              </div>
              {isExpanded && (
                <div>
                  <div
                    style={{
                      display: "flex",
                      gap: 0,
                      borderTop: "1px solid var(--border)",
                      background: "var(--surface2)",
                    }}
                  >
                    {["live", "analytics", "settings"].map((t) => (
                      <button
                        key={t}
                        onClick={() =>
                          setActivePanel((prev) => ({ ...prev, [truck.id]: t }))
                        }
                        style={{
                          flex: 1,
                          padding: "10px 0",
                          border: "none",
                          borderBottom: `2px solid ${
                            panel === t ? "var(--orange)" : "transparent"
                          }`,
                          background: "transparent",
                          color: panel === t ? "var(--orange)" : "var(--muted)",
                          fontWeight: 700,
                          fontSize: 11,
                          letterSpacing: 1,
                          textTransform: "uppercase",
                          cursor: "pointer",
                          transition: "all 0.2s",
                        }}
                      >
                        {t === "live"
                          ? "📍 Live"
                          : t === "analytics"
                          ? "📊 Stats"
                          : "⚙️ Info"}
                      </button>
                    ))}
                  </div>
                  {panel === "live" && (
                    <div className="live-panel">
                      <div className="live-btn-row">
                        <button
                          className={`live-circle ${
                            truck.isOpenNow ? "online" : "offline"
                          }`}
                          onClick={() => toggleLive(truck)}
                          disabled={isToggling}
                        >
                          <div className="live-circle-icon">
                            {isToggling ? "⏳" : truck.isOpenNow ? "🟢" : "⚫"}
                          </div>
                          <div className="live-circle-text">
                            {isToggling
                              ? "..."
                              : truck.isOpenNow
                              ? "APERTO"
                              : "CHIUDI"}
                          </div>
                        </button>
                        <div className="live-info">
                          <div className="live-info-title">
                            {truck.isOpenNow ? "Sei online!" : "Vai online"}
                          </div>
                          <div className="live-info-sub">
                            {truck.isOpenNow
                              ? `Aperto fino alle ${truck.liveUntil}. Tocca per chiudere.`
                              : "Tocca il bottone per condividere la tua posizione."}
                          </div>
                        </div>
                      </div>
                      {truck.isPremium && <CouponQuickScan truck={truck} />}
                      {!truck.isOpenNow && (
                        <div className="live-time-row">
                          <div className="live-time-label">Fino alle</div>
                          <input
                            type="time"
                            className="live-time-input"
                            value={until}
                            onChange={(e) =>
                              setLiveUntil((prev) => ({
                                ...prev,
                                [truck.id]: e.target.value,
                              }))
                            }
                          />
                        </div>
                      )}
                      <button
                        onClick={() => handleDelete(truck)}
                        style={{
                          width: "100%",
                          marginTop: 8,
                          padding: "10px",
                          borderRadius: "var(--radius-sm)",
                          border: "1px solid rgba(255,77,77,0.3)",
                          background: "rgba(255,77,77,0.06)",
                          color: "var(--red)",
                          fontSize: 13,
                          fontWeight: 600,
                          cursor: "pointer",
                        }}
                      >
                        🗑️ Elimina questo truck
                      </button>
                    </div>
                  )}
                  {panel === "analytics" && (
                    <TruckAnalytics truck={truck} reviews={reviews} />
                  )}
                  {panel === "settings" && <TruckSettingsPanel truck={truck} user={user} />}
                </div>
              )}
            </div>
          );
        })}
        {showAddForm && (
          <div className="add-truck-form">
            <div className="add-truck-title">🚚 NUOVO TRUCK</div>
            <input
              className="input-field"
              placeholder="Nome *"
              value={newTruck.name}
              onChange={(e) =>
                setNewTruck({ ...newTruck, name: e.target.value })
              }
            />
            <select
              className="input-field"
              value={newTruck.category}
              onChange={(e) =>
                setNewTruck({ ...newTruck, category: e.target.value })
              }
              style={{ cursor: "pointer" }}
            >
              {Object.keys(categoryEmoji).map((c) => (
                <option key={c}>{c}</option>
              ))}
            </select>
            <input
              className="input-field"
              placeholder="Telefono"
              value={newTruck.phone}
              onChange={(e) =>
                setNewTruck({ ...newTruck, phone: e.target.value })
              }
            />
            <input
              className="input-field"
              placeholder="Instagram (senza @)"
              value={newTruck.instagram}
              onChange={(e) =>
                setNewTruck({ ...newTruck, instagram: e.target.value })
              }
            />
            <textarea
              className="input-field"
              placeholder="Descrizione"
              rows={2}
              style={{ resize: "none" }}
              value={newTruck.description}
              onChange={(e) =>
                setNewTruck({ ...newTruck, description: e.target.value })
              }
            />
            <ImageUploader
              vendorId={`${user.uid}_new_${Date.now()}`}
              currentImage={newTruck.image}
              onUploaded={(url) => setNewTruck({ ...newTruck, image: url })}
            />

            <div style={{ display: "flex", gap: 10, marginTop: 4 }}>
              <button
                className="btn-primary"
                style={{ fontSize: 16, padding: "13px 0" }}
                disabled={saving}
                onClick={handleAddTruck}
              >
                {saving ? "..." : "✅ AGGIUNGI"}
              </button>
              <button
                onClick={() => {
                  setShowAddForm(false);
                  setNewTruck({
                    name: "",
                    category: "Panini",
                    phone: "",
                    instagram: "",
                    description: "",
                    image: "",
                  });
                }}
                style={{
                  flex: 1,
                  padding: "13px 0",
                  borderRadius: "var(--radius)",
                  border: "1.5px solid var(--border)",
                  background: "transparent",
                  color: "var(--muted)",
                  fontWeight: 600,
                  cursor: "pointer",
                }}
              >
                Annulla
              </button>
            </div>
          </div>
        )}
        {!showAddForm && (
          <div style={{ margin: "0 20px" }}>
            <button
              className="btn-secondary"
              style={{ maxWidth: "100%" }}
              onClick={() => setShowAddForm(true)}
            >
              + Aggiungi truck
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

function PremiumCheckout({ truck, user }) {
  const [plan, setPlan] = useState("monthly");
  const [loading, setLoading] = useState(false);

  const priceIds = truck.isAdditionalTruck
    ? {
        monthly: "pri_01m5emjt4dh6m534h4d2b94y3f",
        yearly: "pri_01m5emmrvkx9b9640n09jpf432",
      }
    : {
        monthly: "pri_01m1nwvq65t6eq7mrn294de4m5",
        yearly: "pri_01m1nx3816xgnppxcnmfmkg1s5",
      };
  const priceLabels = truck.isAdditionalTruck
    ? { monthly: "5€/mese", yearly: "45€/anno" }
    : { monthly: "10€/mese", yearly: "90€/anno" };

  const openCheckout = () => {
    if (!window.Paddle) {
      alert("Sistema di pagamento non disponibile. Riprova tra poco.");
      return;
    }
    setLoading(true);
    window.Paddle.Checkout.open({
      items: [{ priceId: priceIds[plan], quantity: 1 }],
      customer: user?.email ? { email: user.email } : undefined,
      customData: { vendorId: truck.id, userId: user.uid },
      settings: { successUrl: window.location.href },
    });
    setTimeout(() => setLoading(false), 1500);
  };

  return (
    <div style={{background:"var(--surface2)",border:"1.5px solid var(--border)",borderRadius:"var(--radius-sm)",padding:16,textAlign:"center"}}>
      <div style={{fontSize:24,marginBottom:8}}>🔒</div>
      <div style={{fontSize:14,color:"var(--cream)",fontWeight:600,marginBottom:4}}>Funzione Premium</div>
      <div style={{fontSize:12,color:"var(--muted)",marginBottom:14}}>Sblocca sconti, coupon monouso, galleria foto e altro.</div>
      <div style={{display:"flex",gap:8,marginBottom:14,justifyContent:"center"}}>
        <button
          onClick={() => setPlan("monthly")}
          style={{padding:"8px 14px",borderRadius:20,border:"1.5px solid",borderColor: plan==="monthly" ? "var(--orange)" : "var(--border)",background: plan==="monthly" ? "rgba(255,107,53,0.12)" : "transparent",color: plan==="monthly" ? "var(--orange)" : "var(--muted)",fontWeight:700,fontSize:13,cursor:"pointer"}}
        >
          {priceLabels.monthly}
        </button>
        <button
          onClick={() => setPlan("yearly")}
          style={{padding:"8px 14px",borderRadius:20,border:"1.5px solid",borderColor: plan==="yearly" ? "var(--orange)" : "var(--border)",background: plan==="yearly" ? "rgba(255,107,53,0.12)" : "transparent",color: plan==="yearly" ? "var(--orange)" : "var(--muted)",fontWeight:700,fontSize:13,cursor:"pointer"}}
        >
          {priceLabels.yearly}
        </button>
      </div>
      <button
        onClick={openCheckout}
        disabled={loading}
        style={{width:"100%",padding:"12px",borderRadius:"var(--radius-sm)",background:"var(--orange)",border:"none",color:"white",fontWeight:700,fontSize:14,cursor:"pointer"}}
      >
        {loading ? "..." : "💳 Passa a Premium"}
      </button>
    </div>
  );
}

function TruckSettingsPanel({ truck, user }) {
  const [saving, setSaving] = useState(false);
  const [geocoding, setGeocoding] = useState(false);
  const [editData, setEditData] = useState({
    name: truck.name || "",
    category: truck.category || "Panini",
    phone: truck.phone || "",
    instagram: truck.instagram || "",
    description: truck.description || "",
    image: truck.image || "",
  });
  const [showScheduleForm, setShowScheduleForm] = useState(false);
  const [newSchedule, setNewSchedule] = useState({
    days: [],
    start: "",
    end: "",
    address: "",
  });
  const weekDays = ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"];
  const toggleDay = (d) =>
    setNewSchedule((prev) => ({
      ...prev,
      days: prev.days.includes(d)
        ? prev.days.filter((x) => x !== d)
        : [...prev.days, d],
    }));
  const premiumExpiryLabel = truck.premiumUntil
    ? (truck.premiumUntil.toDate ? truck.premiumUntil.toDate() : new Date(truck.premiumUntil)).toLocaleDateString("it-IT")
    : null;
  const saveInfo = async () => {
    setSaving(true);
    try {
      await updateDoc(doc(db, "vendors", truck.id), editData);
      alert("✅ Salvato!");
    } catch (e) {
      alert(e.message);
    } finally {
      setSaving(false);
    }
  };
  const addSchedule = async () => {
    if (
      !newSchedule.days.length ||
      !newSchedule.start ||
      !newSchedule.end ||
      !newSchedule.address
    ) {
      alert("Compila tutti i campi");
      return;
    }
    setGeocoding(true);
    try {
      const res = await fetch(
        `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(
          newSchedule.address
        )}&limit=1`,
        { headers: { "Accept-Language": "it" } }
      );
      const data = await res.json();
      if (!data.length) {
        alert("Indirizzo non trovato");
        setGeocoding(false);
        return;
      }
      const entry = {
        ...newSchedule,
        lat: parseFloat(data[0].lat),
        lng: parseFloat(data[0].lon),
      };
      await updateDoc(doc(db, "vendors", truck.id), {
        schedule: [...(truck.schedule || []), entry],
      });
      setNewSchedule({ days: [], start: "", end: "", address: "" });
      setShowScheduleForm(false);
    } catch (e) {
      alert(e.message);
    } finally {
      setGeocoding(false);
    }
  };
  const deleteSchedule = async (i) => {
    const updated = (truck.schedule || []).filter((_, idx) => idx !== i);
    await updateDoc(doc(db, "vendors", truck.id), { schedule: updated });
  };
  return (
    <div style={{ padding: "16px 20px" }}>
      <div
        style={{
          fontSize: 11,
          letterSpacing: 3,
          textTransform: "uppercase",
          color: "var(--orange)",
          fontWeight: 600,
          marginBottom: 12,
        }}
      >
        Profilo
      </div>
      <input
        className="input-field"
        placeholder="Nome *"
        value={editData.name}
        onChange={(e) => setEditData({ ...editData, name: e.target.value })}
      />
      <select
        className="input-field"
        value={editData.category}
        onChange={(e) => setEditData({ ...editData, category: e.target.value })}
        style={{ cursor: "pointer" }}
      >
        {Object.keys(categoryEmoji).map((c) => (
          <option key={c}>{c}</option>
        ))}
      </select>
      <input
        className="input-field"
        placeholder="Telefono"
        value={editData.phone}
        onChange={(e) => setEditData({ ...editData, phone: e.target.value })}
      />
      <input
        className="input-field"
        placeholder="Instagram (senza @)"
        value={editData.instagram}
        onChange={(e) =>
          setEditData({ ...editData, instagram: e.target.value })
        }
      />
      <textarea
        className="input-field"
        placeholder="Descrizione"
        rows={2}
        style={{ resize: "none" }}
        value={editData.description}
        onChange={(e) =>
          setEditData({ ...editData, description: e.target.value })
        }
      />
      <ImageUploader
        vendorId={truck.id}
        currentImage={editData.image}
        onUploaded={(url) => setEditData({ ...editData, image: url })}
      />

      {truck.isPremium && (
        <>
          <div style={{fontSize:11,letterSpacing:3,textTransform:"uppercase",color:"var(--orange)",fontWeight:600,marginBottom:12,marginTop:20}}>Galleria foto (fino a 6)</div>
          <GalleryUploader
            vendorId={truck.id}
            images={truck.images || []}
            onUpdate={(newImages) => updateDoc(doc(db, "vendors", truck.id), { images: newImages })}
          />
        </>
      )}

      <button
        className="btn-primary"
        style={{ fontSize: 16, marginBottom: 20 }}
        disabled={saving}
        onClick={saveInfo}
      >
        {saving ? "..." : "💾 SALVA"}
      </button>
      <div style={{marginBottom:20}}>
        <div style={{fontSize:11,letterSpacing:3,textTransform:"uppercase",color:"var(--orange)",fontWeight:600,marginBottom:12}}>QR Code</div>
        <div style={{background:"white",borderRadius:"var(--radius-sm)",padding:16,display:"flex",flexDirection:"column",alignItems:"center",gap:12}}>
          <img src={`https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(`https://trucky-96c2f.web.app/?truck=${truck.id}`)}`} alt="QR Code" style={{width:200,height:200}} />
          <div style={{fontSize:12,color:"#333",textAlign:"center"}}>Fai scansionare questo codice ai tuoi clienti</div>
          <a href={`https://trucky-96c2f.web.app/?truck=${truck.id}`} style={{fontSize:11,color:"#666",wordBreak:"break-all",textAlign:"center"}}>{`https://trucky-96c2f.web.app/?truck=${truck.id}`}</a>
        </div>
      </div>
      <div
        style={{
          fontSize: 11,
          letterSpacing: 3,
          textTransform: "uppercase",
          color: "var(--orange)",
          fontWeight: 600,
          marginBottom: 12,
        }}
      >
        Schedule
      </div>
      {truck.schedule?.length > 0 ? (
        truck.schedule.map((s, i) => (
          <div
            key={i}
            style={{
              background: "var(--bg)",
              border: "1px solid var(--border)",
              borderRadius: "var(--radius-sm)",
              padding: "12px 14px",
              marginBottom: 8,
              display: "flex",
              gap: 10,
              alignItems: "flex-start",
            }}
          >
            <div style={{ flex: 1 }}>
              <div className="schedule-days">{s.days?.join(" · ")}</div>
              <div className="schedule-time">
                {s.start} – {s.end}
              </div>
              <div className="schedule-addr">{s.address}</div>
            </div>
            <button
              onClick={() => deleteSchedule(i)}
              style={{
                background: "rgba(255,77,77,0.1)",
                border: "1px solid rgba(255,77,77,0.3)",
                color: "var(--red)",
                borderRadius: 8,
                padding: "5px 9px",
                fontSize: 12,
                cursor: "pointer",
                fontWeight: 700,
                flexShrink: 0,
              }}
            >
              ✕
            </button>
          </div>
        ))
      ) : (
        <div style={{ fontSize: 13, color: "var(--muted)", marginBottom: 12 }}>
          Nessuna fascia oraria.
        </div>
      )}
      {!showScheduleForm && (
        <button
          style={{
            width: "100%",
            padding: "11px",
            borderRadius: "var(--radius-sm)",
            border: "1.5px solid var(--border)",
            background: "transparent",
            color: "var(--muted)",
            fontWeight: 600,
            cursor: "pointer",
            marginBottom: 8,
          }}
          onClick={() => setShowScheduleForm(true)}
        >
          + Aggiungi fascia
        </button>
      )}
      {showScheduleForm && (
        <div
          style={{
            background: "var(--bg)",
            border: "1.5px solid var(--orange)",
            borderRadius: "var(--radius-sm)",
            padding: 16,
            marginBottom: 8,
          }}
        >
          <div
            style={{
              display: "flex",
              gap: 5,
              flexWrap: "wrap",
              marginBottom: 12,
            }}
          >
            {weekDays.map((d) => (
              <button
                key={d}
                onClick={() => toggleDay(d)}
                style={{
                  padding: "7px 10px",
                  borderRadius: 7,
                  border: "1.5px solid",
                  borderColor: newSchedule.days.includes(d)
                    ? "var(--orange)"
                    : "var(--border)",
                  background: newSchedule.days.includes(d)
                    ? "rgba(255,107,53,0.15)"
                    : "transparent",
                  color: newSchedule.days.includes(d)
                    ? "var(--orange)"
                    : "var(--muted)",
                  fontWeight: 700,
                  fontSize: 12,
                  cursor: "pointer",
                }}
              >
                {d}
              </button>
            ))}
          </div>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 8,
              marginBottom: 8,
            }}
          >
            <div>
              <div className="section-mini-label" style={{ marginTop: 0 }}>
                Dalle
              </div>
              <input
                type="time"
                className="time-input"
                style={{ marginBottom: 0 }}
                value={newSchedule.start}
                onChange={(e) =>
                  setNewSchedule({ ...newSchedule, start: e.target.value })
                }
              />
            </div>
            <div>
              <div className="section-mini-label" style={{ marginTop: 0 }}>
                Alle
              </div>
              <input
                type="time"
                className="time-input"
                style={{ marginBottom: 0 }}
                value={newSchedule.end}
                onChange={(e) =>
                  setNewSchedule({ ...newSchedule, end: e.target.value })
                }
              />
            </div>
          </div>
          <input
            className="input-field"
            placeholder="Indirizzo"
            value={newSchedule.address}
            onChange={(e) =>
              setNewSchedule({ ...newSchedule, address: e.target.value })
            }
          />
          <div style={{ display: "flex", gap: 8 }}>
            <button
              style={{
                flex: 2,
                padding: "10px",
                borderRadius: "var(--radius-sm)",
                background: "var(--orange)",
                border: "none",
                color: "white",
                fontWeight: 700,
                cursor: "pointer",
              }}
              disabled={geocoding}
              onClick={addSchedule}
            >
              {geocoding ? "🔍..." : "✅ Salva"}
            </button>
            <button
              onClick={() => {
                setShowScheduleForm(false);
                setNewSchedule({ days: [], start: "", end: "", address: "" });
              }}
              style={{
                flex: 1,
                padding: "10px",
                borderRadius: "var(--radius-sm)",
                border: "1.5px solid var(--border)",
                background: "transparent",
                color: "var(--muted)",
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              Annulla
            </button>
          </div>
        </div>
      )}

      <div style={{marginTop:16,marginBottom:8}}>
        <div style={{fontSize:11,letterSpacing:3,textTransform:"uppercase",color:"var(--orange)",fontWeight:600,marginBottom:12}}>Sconti & Coupon</div>
        {!truck.isPremium ? (
          <PremiumCheckout truck={truck} user={user} />
        ) : (
          <>
            {premiumExpiryLabel && (
              <div style={{fontSize:12,color:"var(--muted)",marginBottom:12}}>
                Premium attivo fino al {premiumExpiryLabel}
              </div>
            )}
            <DiscountManager truck={truck} />
          </>
        )}
      </div>
    </div>
  );
}

function ClientCoupons({ vendor, user }) {
  const [discounts, setDiscounts] = useState([]);
  const [myCoupons, setMyCoupons] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onSnapshot(
      query(collection(db, "discounts"), where("vendorId", "==", vendor.id), where("active", "==", true)),
      (snap) => { setDiscounts(snap.docs.map(d => ({ id: d.id, ...d.data() }))); setLoading(false); }
    );
    return () => unsub();
  }, [vendor.id]);

  useEffect(() => {
    if (!user) { setLoading(false); return; }
    const unsub = onSnapshot(
      query(collection(db, "coupons"), where("userId", "==", user.uid), where("vendorId", "==", vendor.id)),
      (snap) => {
        setMyCoupons(snap.docs.map(d => ({ id: d.id, ...d.data() })));
        setLoading(false);
      }
    );
    return () => unsub();
  }, [user, vendor.id]);

  const getCoupon = async (discount) => {
    if (!user) { alert("Accedi per ottenere un coupon"); return; }
    const already = myCoupons.find(c => c.discountId === discount.id);
    if (already) { alert("Hai già utilizzato questo coupon!"); return; }
    const couponId = `${user.uid}_${discount.id}_${Date.now()}`;
    await addDoc(collection(db, "coupons"), {
      couponId, discountId: discount.id, userId: user.uid,
      vendorId: vendor.id, usato: false, createdAt: new Date(),
    });
    alert("✅ Coupon ottenuto! Mostralo al venditore.");
  };

  if (loading) return <div style={{fontSize:13,color:"var(--muted)"}}>Caricamento...</div>;
  if (discounts.length === 0) return <div style={{fontSize:13,color:"var(--muted)",marginBottom:8}}>Nessuno sconto disponibile al momento.</div>;

  return (
    <div>
      {discounts.map(d => {
        const myCoupon = myCoupons.find(c => c.discountId === d.id);
        const isUsato = myCoupon && myCoupon.usato === true;
        return (
          <div key={d.id} style={{position:"relative",background:"var(--surface)",border:`1.5px solid ${isUsato ? "rgba(255,77,77,0.4)" : myCoupon ? "var(--green)" : "var(--border)"}`,borderRadius:"var(--radius-sm)",padding:"14px 16px",marginBottom:10,opacity: isUsato ? 0.7 : 1,overflow:"hidden"}}>
            {isUsato && (
              <div style={{position:"absolute",inset:0,display:"flex",alignItems:"center",justifyContent:"center",pointerEvents:"none",zIndex:2}}>
                <div style={{background:"rgba(255,77,77,0.15)",border:"2px solid var(--red)",borderRadius:8,padding:"6px 20px",transform:"rotate(-15deg)",fontSize:18,fontWeight:900,color:"var(--red)",letterSpacing:3,textTransform:"uppercase"}}>USATO</div>
              </div>
            )}
            <div style={{fontSize:15,fontWeight:700,color: isUsato ? "var(--muted)" : "var(--cream)",marginBottom:4,textDecoration: isUsato ? "line-through" : "none"}}>{d.name}</div>
            {d.description && <div style={{fontSize:13,color:"var(--muted)",marginBottom:10,textDecoration: isUsato ? "line-through" : "none"}}>{d.description}</div>}
            {isUsato ? (
              <div style={{fontSize:12,color:"var(--red)",fontWeight:600}}>❌ Coupon già utilizzato</div>
            ) : myCoupon ? (
              <div>
                <div style={{fontSize:12,color:"var(--green)",fontWeight:600,marginBottom:8}}>✅ Coupon attivo — mostralo al venditore</div>
                <img src={`https://api.qrserver.com/v1/create-qr-code/?size=160x160&data=${myCoupon.couponId}`} alt="Coupon QR" style={{width:160,height:160,borderRadius:8,background:"white",padding:4}} />
              </div>
            ) : (
              <button onClick={() => getCoupon(d)} style={{background:"var(--orange)",color:"white",border:"none",borderRadius:"var(--radius-sm)",padding:"10px 16px",fontSize:13,fontWeight:700,cursor:"pointer",width:"100%"}}>
                🎟️ Ottieni coupon
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
}

function DiscountManager({ truck }) {
  const [discounts, setDiscounts] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [newDiscount, setNewDiscount] = useState({ name: "", description: "" });
  const [saving, setSaving] = useState(false);
  const [showScanner, setShowScanner] = useState(false);
  const [scanResult, setScanResult] = useState(null);

  useEffect(() => {
    const unsub = onSnapshot(
      query(collection(db, "discounts"), where("vendorId", "==", truck.id)),
      (snap) => setDiscounts(snap.docs.map(d => ({ id: d.id, ...d.data() })))
    );
    return () => unsub();
  }, [truck.id]);

  const addDiscount = async () => {
    if (!newDiscount.name) { alert("Inserisci il nome dello sconto"); return; }
    setSaving(true);
    try {
      await addDoc(collection(db, "discounts"), {
        ...newDiscount, vendorId: truck.id, active: true, createdAt: new Date(),
      });
      setNewDiscount({ name: "", description: "" });
      setShowForm(false);
    } catch (e) { alert(e.message); }
    finally { setSaving(false); }
  };

  const deleteDiscount = async (id) => {
    if (!window.confirm("Eliminare questo sconto?")) return;
    await deleteDoc(doc(db, "discounts", id));
  };

  const handleScan = async (data) => {
    setShowScanner(false);
    try {
      const couponSnap = await getDocs(query(collection(db, "coupons"), where("couponId", "==", data)));
      if (couponSnap.empty) { setScanResult({ ok: false, msg: "Coupon non trovato o non valido." }); return; }
      const couponDoc = couponSnap.docs[0];
      const coupon = couponDoc.data();
      if (coupon.usato) { setScanResult({ ok: false, msg: "Coupon già utilizzato!" }); return; }
      if (coupon.vendorId !== truck.id) { setScanResult({ ok: false, msg: "Coupon non valido per questo truck." }); return; }
      await updateDoc(doc(db, "coupons", couponDoc.id), { usato: true, usatoAt: new Date() });
      const discountSnap = await getDocs(query(collection(db, "discounts"), where("__name__", "==", coupon.discountId)));
      const discountName = discountSnap.empty ? "Sconto" : discountSnap.docs[0].data().name;
      setScanResult({ ok: true, msg: `✅ Coupon valido! Applica: ${discountName}` });
    } catch (e) { setScanResult({ ok: false, msg: "Errore durante la verifica." }); }
  };

  return (
    <div>
      {showScanner && <QRScanner onScan={handleScan} onClose={() => setShowScanner(false)} />}
      {scanResult && (
        <div style={{background: scanResult.ok ? "rgba(57,211,83,0.1)" : "rgba(255,77,77,0.1)", border: `1px solid ${scanResult.ok ? "rgba(57,211,83,0.3)" : "rgba(255,77,77,0.3)"}`, borderRadius:"var(--radius-sm)",padding:14,marginBottom:12,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div style={{fontSize:14,color: scanResult.ok ? "var(--green)" : "var(--red)",fontWeight:600}}>{scanResult.msg}</div>
          <button onClick={() => setScanResult(null)} style={{background:"none",border:"none",color:"var(--muted)",cursor:"pointer",fontSize:18}}>✕</button>
        </div>
      )}
      <button onClick={() => setShowScanner(true)} style={{width:"100%",padding:12,borderRadius:"var(--radius-sm)",background:"var(--surface2)",border:"1.5px solid var(--orange)",color:"var(--orange)",fontWeight:700,fontSize:14,cursor:"pointer",marginBottom:12}}>
        📷 Scansiona coupon cliente
      </button>
      {discounts.map(d => (
        <div key={d.id} style={{background:"var(--bg)",border:"1px solid var(--border)",borderRadius:"var(--radius-sm)",padding:"12px 14px",marginBottom:8,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div>
            <div style={{fontSize:14,fontWeight:700,color:"var(--cream)"}}>{d.name}</div>
            {d.description && <div style={{fontSize:12,color:"var(--muted)",marginTop:2}}>{d.description}</div>}
          </div>
          <button onClick={() => deleteDiscount(d.id)} style={{background:"rgba(255,77,77,0.1)",border:"1px solid rgba(255,77,77,0.3)",color:"var(--red)",borderRadius:8,padding:"5px 9px",fontSize:12,cursor:"pointer",fontWeight:700}}>✕</button>
        </div>
      ))}
      {!showForm ? (
        <button onClick={() => setShowForm(true)} style={{width:"100%",padding:11,borderRadius:"var(--radius-sm)",border:"1.5px solid var(--border)",background:"transparent",color:"var(--muted)",fontWeight:600,cursor:"pointer"}}>+ Aggiungi sconto</button>
      ) : (
        <div style={{background:"var(--bg)",border:"1.5px solid var(--orange)",borderRadius:"var(--radius-sm)",padding:16,marginBottom:8}}>
          <input className="input-field" placeholder="Nome sconto (es: 10% di sconto)" value={newDiscount.name} onChange={e => setNewDiscount({...newDiscount, name: e.target.value})} />
          <input className="input-field" placeholder="Descrizione (opzionale)" value={newDiscount.description} onChange={e => setNewDiscount({...newDiscount, description: e.target.value})} />
          <div style={{display:"flex",gap:8}}>
            <button onClick={addDiscount} disabled={saving} style={{flex:2,padding:10,borderRadius:"var(--radius-sm)",background:"var(--orange)",border:"none",color:"white",fontWeight:700,cursor:"pointer"}}>{saving ? "..." : "✅ Salva"}</button>
            <button onClick={() => { setShowForm(false); setNewDiscount({name:"",description:""}); }} style={{flex:1,padding:10,borderRadius:"var(--radius-sm)",border:"1.5px solid var(--border)",background:"transparent",color:"var(--muted)",fontWeight:600,cursor:"pointer"}}>Annulla</button>
          </div>
        </div>
      )}
    </div>
  );
}

function QRScanner({ onScan, onClose }) {
  const videoRef = React.useRef(null);
  const canvasRef = React.useRef(null);
  const [error, setError] = React.useState("");

  React.useEffect(() => {
    let stream = null;
    let animFrame = null;
    const startCamera = async () => {
      try {
        stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment" } });
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          videoRef.current.play();
          scan();
        }
      } catch (e) { setError("Impossibile accedere alla camera."); }
    };
    const scan = () => {
      if (!videoRef.current || !canvasRef.current) return;
      const video = videoRef.current;
      const canvas = canvasRef.current;
      const ctx = canvas.getContext("2d");
      if (video.readyState === video.HAVE_ENOUGH_DATA) {
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const jsQR = require("jsqr");
        const code = jsQR(imageData.data, imageData.width, imageData.height);
        if (code) { onScan(code.data); return; }
      }
      animFrame = requestAnimationFrame(scan);
    };
    startCamera();
    return () => {
      if (stream) stream.getTracks().forEach(t => t.stop());
      if (animFrame) cancelAnimationFrame(animFrame);
    };
  }, []);

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.95)",zIndex:300,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
      <div style={{fontSize:11,letterSpacing:3,textTransform:"uppercase",color:"var(--orange)",fontWeight:600,marginBottom:16}}>Scansiona coupon cliente</div>
      {error ? (
        <div style={{color:"var(--red)",fontSize:14,textAlign:"center",padding:"0 24px"}}>{error}</div>
      ) : (
        <div style={{position:"relative",width:280,height:280,borderRadius:16,overflow:"hidden",border:"2px solid var(--orange)"}}>
          <video ref={videoRef} style={{width:"100%",height:"100%",objectFit:"cover"}} muted playsInline />
          <canvas ref={canvasRef} style={{display:"none"}} />
        </div>
      )}
      <button onClick={onClose} style={{marginTop:24,background:"var(--surface)",border:"1.5px solid var(--border)",color:"var(--cream)",padding:"12px 32px",borderRadius:"var(--radius)",fontSize:15,fontWeight:600,cursor:"pointer"}}>✕ Chiudi</button>
    </div>
  );
}


function CouponQuickScan({ truck }) {
  const [showScanner, setShowScanner] = useState(false);
  const [scanResult, setScanResult] = useState(null);

  const handleScan = async (data) => {
    setShowScanner(false);
    try {
      const couponSnap = await getDocs(query(collection(db, "coupons"), where("couponId", "==", data)));
      if (couponSnap.empty) { setScanResult({ ok: false, msg: "Coupon non trovato o non valido." }); return; }
      const couponDoc = couponSnap.docs[0];
      const coupon = couponDoc.data();
      if (coupon.usato) { setScanResult({ ok: false, msg: "Coupon gi\u00e0 utilizzato!" }); return; }
      if (coupon.vendorId !== truck.id) { setScanResult({ ok: false, msg: "Coupon non valido per questo truck." }); return; }
      await updateDoc(doc(db, "coupons", couponDoc.id), { usato: true, usatoAt: new Date() });
      const discountSnap = await getDocs(query(collection(db, "discounts"), where("__name__", "==", coupon.discountId)));
      const discountName = discountSnap.empty ? "Sconto" : discountSnap.docs[0].data().name;
      setScanResult({ ok: true, msg: `\u2705 Coupon valido! Applica: ${discountName}` });
    } catch (e) {
      setScanResult({ ok: false, msg: "Errore durante la verifica." });
    }
  };

  return (
    <div style={{ marginTop: 14 }}>
      {showScanner && <QRScanner onScan={handleScan} onClose={() => setShowScanner(false)} />}
      {scanResult && (
        <div style={{background: scanResult.ok ? "rgba(57,211,83,0.1)" : "rgba(255,77,77,0.1)", border: `1px solid ${scanResult.ok ? "rgba(57,211,83,0.3)" : "rgba(255,77,77,0.3)"}`, borderRadius:"var(--radius-sm)",padding:14,marginBottom:12,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
          <div style={{fontSize:14,color: scanResult.ok ? "var(--green)" : "var(--red)",fontWeight:600}}>{scanResult.msg}</div>
          <button onClick={() => setScanResult(null)} style={{background:"none",border:"none",color:"var(--muted)",cursor:"pointer",fontSize:18}}>✕</button>
        </div>
      )}
      <button
        onClick={() => setShowScanner(true)}
        style={{
          width: "100%",
          padding: "14px",
          borderRadius: "var(--radius)",
          background: "linear-gradient(135deg, var(--orange), #ff8558)",
          border: "none",
          color: "white",
          fontWeight: 700,
          fontSize: 15,
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 8,
          boxShadow: "0 4px 16px rgba(255,107,53,0.35)",
        }}
      >
        🎟️ Scansiona coupon cliente
      </button>
    </div>
  );
}

function WizardStep({ step, stepIndex, totalSteps, onSelect, onBack }) {
  const [selected, setSelected] = useState(null);
  const handleSelect = (v) => {
    setSelected(v);
    setTimeout(() => onSelect(v), 300);
  };
  const progress = (stepIndex / totalSteps) * 100;
  return (
    <div className="wizard">
      <div className="wizard-header">
        <button className="wizard-back" onClick={onBack}>
          ←
        </button>
        <div className="progress-bar">
          <div className="progress-fill" style={{ width: `${progress}%` }} />
        </div>
      </div>
      <div className="wizard-body" key={stepIndex}>
        <div className="wizard-step-label">{step.label}</div>
        <div className="wizard-question">{step.question}</div>
        <div className="wizard-hint">{step.hint}</div>
        <div className={`options-grid ${step.cols === 1 ? "single-col" : ""}`}>
          {step.options.map((opt) => (
            <div
              key={opt.value}
              className={`option-card ${
                selected === opt.value ? "selected" : ""
              }`}
              onClick={() => handleSelect(opt.value)}
            >
              {selected === opt.value && (
                <div className="selected-check">✓</div>
              )}
              <div className="option-emoji">{opt.emoji}</div>
              <div className="option-label">{opt.label}</div>
              {opt.sub && <div className="option-sub">{opt.sub}</div>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function TruckCard({ vendor, onOpen, onFavorite, isFav, favCount }) {
  const emoji = categoryEmoji[vendor.category] || "📍";
  return (
    <div className="truck-card" onClick={() => onOpen(vendor)}>
      {vendor.image ? (
        <img
          src={vendor.image}
          alt={vendor.name}
          className="truck-img"
          style={{ objectFit: "cover" }}
        />
      ) : (
        <div className="truck-img">{emoji}</div>
      )}
      <div className="truck-info">
        <div className="truck-cat">{vendor.category}</div>
        <div className="truck-name">{vendor.name}</div>
        <div className="truck-meta">
          {vendor.isOpenNow ? (
            <span className="badge-open">● Aperto</span>
          ) : (
            <span className="badge-closed">Chiuso</span>
          )}
          {vendor.distanceKm != null && vendor.distanceKm < 9999 && (
            <span className="truck-distance">📍 {vendor.distanceKm} km</span>
          )}
        </div>
        <div className="truck-meta" style={{ marginTop: 0 }}>
          <div className="truck-rating">
            <span className="star">★</span> {vendor.avgRating || "–"}{" "}
            <span
              style={{ color: "var(--muted)", fontWeight: 400, fontSize: 12 }}
            >
              ({vendor.reviewCount || 0})
            </span>
          </div>
          <span className="truck-favcount">❤️ {favCount || 0}</span>
        </div>
      </div>
      <button
        className="truck-fav"
        onClick={(e) => {
          e.stopPropagation();
          onFavorite(vendor.id);
        }}
      >
        {isFav ? "❤️" : "🤍"}
      </button>
    </div>
  );
}

function TruckDetail({ vendor, reviews, favCount, user, userData, onBack }) {
  const truckReviews = reviews.filter((r) => r.vendorId === vendor.id);
  const avg = truckReviews.length
    ? (
        truckReviews.reduce((a, b) => a + b.rating, 0) / truckReviews.length
      ).toFixed(1)
    : "–";
  const emoji = categoryEmoji[vendor.category] || "📍";
  const [rating, setRating] = useState(5);
  const [comment, setComment] = useState("");
  const [hovered, setHovered] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const myReview = user
    ? truckReviews.find((r) => r.userId === user.uid)
    : null;
  useEffect(() => {
    if (myReview) {
      setRating(myReview.rating);
      setComment(myReview.comment);
    }
  }, [myReview?.id]);
  const submitReview = async () => {
    if (!comment.trim()) return;
    setSubmitting(true);
    try {
      if (myReview) {
        await updateDoc(doc(db, "reviews", myReview.id), {
          rating,
          comment,
          updatedAt: new Date(),
        });
      } else {
        await addDoc(collection(db, "reviews"), {
          vendorId: vendor.id,
          userId: user.uid,
          rating,
          comment,
          createdAt: new Date(),
        });
      }
    } catch (e) {
      console.error(e);
    } finally {
      setSubmitting(false);
    }
  };
  return (
    <div className="detail">
      <div style={{ position: "relative" }}>
        <TruckHeroGallery vendor={vendor} />
        <button
          onClick={onBack}
          style={{
            position: "absolute",
            top: 16,
            left: 16,
            background: "rgba(0,0,0,0.6)",
            border: "none",
            color: "#fff",
            borderRadius: "50%",
            width: 40,
            height: 40,
            fontSize: 18,
            cursor: "pointer",
            backdropFilter: "blur(4px)",
          }}
        >
          ←
        </button>
      </div>
      <div className="detail-body">
        <div className="detail-header">
          <div>
            <div
              style={{
                fontSize: 12,
                letterSpacing: 3,
                textTransform: "uppercase",
                color: "var(--orange)",
                marginBottom: 4,
                fontWeight: 600,
              }}
            >
              {vendor.category}
            </div>
            <div className="detail-name">{vendor.name}</div>
          </div>
          <div style={{ textAlign: "right" }}>
            {vendor.isOpenNow ? (
              <span className="badge-open">● Aperto ora</span>
            ) : (
              <span className="badge-closed">Chiuso</span>
            )}
            <div
              style={{
                fontSize: 20,
                marginTop: 8,
                fontWeight: 700,
                color: "var(--cream)",
              }}
            >
              <span className="star">★</span> {avg}
            </div>
            <div style={{ fontSize: 12, color: "var(--muted)" }}>
              {truckReviews.length} recensioni
            </div>
            <div className="detail-favcount">❤️ {favCount || 0} preferiti</div>
          </div>
        </div>

        {vendor.liveUntil && vendor.isOpenNow && (
          <div
            style={{
              background: "rgba(57,211,83,0.1)",
              border: "1px solid rgba(57,211,83,0.2)",
              borderRadius: 10,
              padding: "10px 14px",
              fontSize: 14,
              color: "var(--green)",
              marginBottom: 12,
            }}
          >
            ⏰ Aperto fino alle {vendor.liveUntil}
          </div>
        )}
        {vendor.description && (
          <p
            style={{
              fontSize: 15,
              color: "var(--muted)",
              lineHeight: 1.6,
              marginBottom: 8,
            }}
          >
            {vendor.description}
          </p>
        )}
        <div className="detail-actions">
          {vendor.lat != null && (
            <button
              className="action-btn primary"
              onClick={() =>
                window.open(
                  `https://www.google.com/maps/dir/?api=1&destination=${vendor.lat},${vendor.lng}`
                )
              }
            >
              🧭 Portami lì
            </button>
          )}
          {vendor.phone && (
            <a href={`tel:${vendor.phone}`} className="action-btn">
              📞 Chiama
            </a>
          )}
          {vendor.instagram && (
            <a
              href={`https://instagram.com/${vendor.instagram}`}
              target="_blank"
              rel="noreferrer"
              className="action-btn"
            >
              📷 IG
            </a>
          )}
        </div>
        {vendor.schedule?.length > 0 && (
          <>
            <div className="divider" />
            <div className="section-label">📅 Dove sono</div>
            {vendor.schedule.map((s, i) => (
              <div key={i} className="schedule-item">
                <div style={{ fontSize: 20, flexShrink: 0 }}>📍</div>
                <div>
                  <div className="schedule-days">{s.days?.join(" · ")}</div>
                  <div className="schedule-time">
                    {s.start} – {s.end}
                  </div>
                  <div className="schedule-addr">{s.address}</div>
                </div>
              </div>
            ))}
          </>
        )}
        <div className="divider" />
        <div className="section-label">🎟️ Sconti & Coupon</div>
        <ClientCoupons vendor={vendor} user={user} />
        <div className="divider" />
        <div className="section-label">
          ⭐ Recensioni ({truckReviews.length})
        </div>
        {truckReviews.length === 0 && (
          <div
            style={{ fontSize: 13, color: "var(--muted)", marginBottom: 16 }}
          >
            Nessuna recensione ancora. Sii il primo!
          </div>
        )}
        {truckReviews.map((r) => (
          <div key={r.id} className="review-item">
            <div className="review-stars">
              {[1, 2, 3, 4, 5].map((i) => (
                <span
                  key={i}
                  style={{
                    color: i <= r.rating ? "#FFD700" : "var(--border)",
                    fontSize: 14,
                  }}
                >
                  ★
                </span>
              ))}
            </div>
            <div className="review-text">{r.comment}</div>
          </div>
        ))}
        {user && userData?.role === "client" && (
          <div className="review-form">
            <div className="review-form-title">{myReview ? "MODIFICA LA TUA RECENSIONE" : "LASCIA UNA RECENSIONE"}</div>
            <div className="star-selector">
              {[1, 2, 3, 4, 5].map((i) => (
                <button
                  key={i}
                  className="star-btn"
                  onMouseEnter={() => setHovered(i)}
                  onMouseLeave={() => setHovered(null)}
                  onClick={() => setRating(i)}
                  style={{
                    color:
                      i <= (hovered || rating) ? "#FFD700" : "var(--border)",
                  }}
                >
                  ★
                </button>
              ))}
            </div>
            <textarea
              className="input-field"
              placeholder="Com'è andata?"
              rows={3}
              style={{ resize: "none" }}
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            />
            <button
              className="btn-primary"
              style={{ fontSize: 16 }}
              disabled={submitting || !comment.trim()}
              onClick={submitReview}
            >
              {submitting ? "..." : myReview ? "AGGIORNA RECENSIONE" : "INVIA RECENSIONE"}
            </button>
          </div>
        )}
        {!user && (
          <div
            style={{
              background: "var(--surface)",
              border: "1px solid var(--border)",
              borderRadius: "var(--radius)",
              padding: 16,
              textAlign: "center",
              marginTop: 16,
            }}
          >
            <div style={{ fontSize: 13, color: "var(--muted)" }}>
              Accedi per lasciare una recensione
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

function AvatarUploader({ user, currentPhoto }) {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState("");

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) { setError("Seleziona un file immagine."); return; }
    if (file.size > 15 * 1024 * 1024) { setError("L'immagine deve essere sotto i 15MB."); return; }
    setError("");
    setUploading(true);
    try {
      const resized = await resizeImage(file);
      const storageRef = ref(storage, `users/${user.uid}/avatar.jpg`);
      await uploadBytes(storageRef, resized);
      const url = await getDownloadURL(storageRef);
      await updateDoc(doc(db, "users", user.uid), { photoURL: url });
    } catch (err) {
      console.error(err);
      setError("Errore durante l'upload. Riprova.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", margin: "8px 0 20px" }}>
      <label style={{ position: "relative", cursor: uploading ? "not-allowed" : "pointer", display: "block" }}>
        {currentPhoto ? (
          <img src={currentPhoto} alt="Foto profilo" style={{ width: 88, height: 88, borderRadius: "50%", objectFit: "cover", border: "2px solid var(--orange)" }} />
        ) : (
          <div style={{ width: 88, height: 88, borderRadius: "50%", background: "var(--surface2)", border: "2px dashed var(--border)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 32 }}>🧑</div>
        )}
        <div style={{ position: "absolute", bottom: 0, right: 0, background: "var(--orange)", borderRadius: "50%", width: 28, height: 28, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, border: "2px solid var(--bg)" }}>
          {uploading ? "…" : "✎"}
        </div>
        <input type="file" accept="image/*" onChange={handleFileChange} disabled={uploading} style={{ display: "none" }} />
      </label>
      {error && <div className="error-msg" style={{ marginTop: 8 }}>{error}</div>}
    </div>
  );
}

function MyCoupons({ user, vendors, onOpenTruck }) {
  const [coupons, setCoupons] = useState([]);
  const [discountNames, setDiscountNames] = useState({});

  useEffect(() => {
    if (!user) return;
    const unsub = onSnapshot(
      query(collection(db, "coupons"), where("userId", "==", user.uid)),
      (snap) => {
        const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        list.sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));
        setCoupons(list);
      }
    );
    return () => unsub();
  }, [user]);

  useEffect(() => {
    coupons.forEach((c) => {
      if (!c.discountId || discountNames[c.discountId] !== undefined) return;
      getDoc(doc(db, "discounts", c.discountId))
        .then((snap) => {
          setDiscountNames((prev) => ({ ...prev, [c.discountId]: snap.exists() ? snap.data().name : "Sconto" }));
        })
        .catch(() => {
          setDiscountNames((prev) => ({ ...prev, [c.discountId]: "Sconto" }));
        });
    });
  }, [coupons]);

  if (coupons.length === 0) {
    return (
      <div style={{ fontSize: 13, color: "var(--muted)", textAlign: "center", padding: "12px 0" }}>
        Non hai ancora nessun coupon.
      </div>
    );
  }

  return (
    <div>
      {coupons.map((c) => {
        const vendor = vendors.find((v) => v.id === c.vendorId);
        return (
          <div
            key={c.id}
            onClick={() => vendor && onOpenTruck(vendor)}
            style={{
              background: "var(--surface)",
              border: `1px solid ${c.usato ? "var(--border)" : "var(--green)"}`,
              borderRadius: "var(--radius-sm)",
              padding: "12px 14px",
              marginBottom: 8,
              opacity: c.usato ? 0.6 : 1,
              cursor: vendor ? "pointer" : "default",
            }}
          >
            <div style={{ fontSize: 12, color: "var(--orange)", fontWeight: 700, textTransform: "uppercase", letterSpacing: 1 }}>
              {vendor?.name || "Venditore non più disponibile"}
            </div>
            <div style={{ fontSize: 14, color: "var(--cream)", fontWeight: 600, marginTop: 2 }}>
              {discountNames[c.discountId] || "..."}
            </div>
            <div style={{ fontSize: 12, color: c.usato ? "var(--red)" : "var(--green)", fontWeight: 600, marginTop: 6 }}>
              {c.usato ? "✕ Usato" : "✓ Attivo"}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default function App() {
  const [user, setUser] = useState(null);
  const [userData, setUserData] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);
  const [showAuthSheet, setShowAuthSheet] = useState(false);
  const [screen, setScreen] = useState("splash");
  const [wizardStep, setWizardStep] = useState(0);
  const [wizardAnswers, setWizardAnswers] = useState({});
  const [selectedTruck, setSelectedTruck] = useState(null);
  const [activeNav, setActiveNav] = useState("map");
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [search, setSearch] = useState("");
  const [activeChip, setActiveChip] = useState(null);
  const [assistantMsg, setAssistantMsg] = useState(
    "Ciao! Cosa stai cercando oggi? 👇"
  );
  const [assistantChips, setAssistantChips] = useState([
    "Aperto ora",
    "Vicino a me",
    "Top rated",
  ]);
  const [vendors, setVendors] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [favorites, setFavorites] = useState([]);
  const [userPosition, setUserPosition] = useState(null);
  const [locationUnavailable, setLocationUnavailable] = useState(false);
  const [, forceRerender] = useState(0);

  // QR Code: gestione apertura link ?truck=ID
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const truckId = params.get("truck");
    if (!truckId) return;
    const handleQR = async () => {
      if (user) {
        const already = await getDocs(query(collection(db, "favorites"), where("userId", "==", user.uid), where("vendorId", "==", truckId)));
        if (already.empty) {
          await addDoc(collection(db, "favorites"), { userId: user.uid, vendorId: truckId });
        }
        const truckSnap = await getDocs(query(collection(db, "vendors"), where("__name__", "==", truckId)));
        if (!truckSnap.empty) setSelectedTruck({ id: truckSnap.docs[0].id, ...truckSnap.docs[0].data() });
        window.history.replaceState({}, "", "/");
        setScreen("main");
      } else {
        setShowAuthSheet(true);
      }
    };
    handleQR();
  }, [user]);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (u) => {
      setUser(u);
      if (u) {
        const snap = await getDoc(doc(db, "users", u.uid));
        if (snap.exists()) setUserData(snap.data());
      } else setUserData(null);
      setAuthLoading(false);
    });
    return () => unsub();
  }, []);

  // FCM — notifiche push
  // Notifiche push su app nativa (Android/iOS via Capacitor)
  useEffect(() => {
    if (!user) return;
    if (!Capacitor.isNativePlatform()) return;

    const initNativePush = async () => {
      try {
        let permStatus = await PushNotifications.checkPermissions();
        if (permStatus.receive !== "granted") {
          permStatus = await PushNotifications.requestPermissions();
        }
        if (permStatus.receive !== "granted") {
          console.log("Permesso notifiche native non concesso");
          return;
        }

        await PushNotifications.register();

        PushNotifications.addListener("registration", async (token) => {
          await updateDoc(doc(db, "users", user.uid), {
            fcmToken: token.value,
          });
          console.log("FCM token nativo salvato");
        });

        PushNotifications.addListener("registrationError", (err) => {
          console.log("Errore registrazione push native:", err);
        });

        // Su Android il sistema mostra la notifica automaticamente
        // in background; qui gestiamo solo il caso app in foreground
        PushNotifications.addListener(
          "pushNotificationReceived",
          (notification) => {
            console.log("Notifica ricevuta (foreground):", notification);
          }
        );

        PushNotifications.addListener(
          "pushNotificationActionPerformed",
          (notification) => {
            console.log("Notifica aperta dall'utente:", notification);
          }
        );
      } catch (e) {
        console.log("Errore init push native:", e);
      }
    };

    initNativePush();
  }, [user]);

  // Notifiche push su web/PWA (Firebase Web Messaging)
  useEffect(() => {
    if (!user) return;
    if (Capacitor.isNativePlatform()) return;

    const initFCM = async () => {
      try {
        const msgInstance = await messaging;
        if (!msgInstance) return;
        const permission = await Notification.requestPermission();
        if (permission !== "granted") return;
        const token = await getToken(msgInstance, {
          vapidKey:
            "BP8nZaECTX3b6EUK4AqOfYzbcMA8Fd6HlrVnCx1hn_UVvo9DATQh9VWBHy5V0-6FS8EGx9Ee_WyUHNaA3mNfijo",
        });
        if (token) {
          await updateDoc(doc(db, "users", user.uid), { fcmToken: token });
          console.log("FCM token salvato");
        }
        onMessage(msgInstance, (payload) => {
          const { title, body } = payload.notification;
          if (Notification.permission === "granted") {
            new Notification(title, { body, icon: "/logo.svg" });
          }
        });
      } catch (e) {
        console.log("FCM non disponibile:", e);
      }
    };
    initFCM();
  }, [user]);

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (pos) => setUserPosition([pos.coords.latitude, pos.coords.longitude]),
      () => {
        setUserPosition(null);
        setLocationUnavailable(true);
      }
    );
  }, []);

  useEffect(() => {
    const unsub = onSnapshot(collection(db, "vendors"), (snap) =>
      setVendors(snap.docs.map((d) => ({ id: d.id, ...d.data() })))
    );
    return () => unsub();
  }, []);
  useEffect(() => {
    const unsub = onSnapshot(collection(db, "reviews"), (snap) =>
      setReviews(snap.docs.map((d) => ({ id: d.id, ...d.data() })))
    );
    return () => unsub();
  }, []);
  // Preferiti pubblici: caricati sempre, anche da ospiti, così la
  // conta dei cuori è visibile a chiunque guardi un truck.
  useEffect(() => {
    const unsub = onSnapshot(collection(db, "favorites"), (snap) =>
      setFavorites(snap.docs.map((d) => ({ id: d.id, ...d.data() })))
    );
    return () => unsub();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      vendors.forEach(async (v) => {
        if (v.liveUntil && v.isOpenNow) {
          const [h, m] = v.liveUntil.split(":");
          const baseDate = v.lastUpdated?.toDate
            ? v.lastUpdated.toDate()
            : new Date(v.lastUpdated || Date.now());
          const limit = new Date(baseDate);
          limit.setHours(+h, +m, 0, 0);
          if (limit < baseDate) {
            limit.setDate(limit.getDate() + 1);
          }
          if (new Date() > limit)
            await updateDoc(doc(db, "vendors", v.id), { isOpenNow: false });
        }
        if (v.isPremium && v.premiumUntil) {
          const expiry = v.premiumUntil.toDate ? v.premiumUntil.toDate() : new Date(v.premiumUntil);
          if (new Date() > expiry) {
            await updateDoc(doc(db, "vendors", v.id), { isPremium: false });
          }
        }
      });
    }, 60000);
    return () => clearInterval(interval);
  }, [vendors]);

  const getAvgRating = (id) => {
    const r = reviews.filter((x) => x.vendorId === id);
    if (!r.length) return null;
    return (r.reduce((a, b) => a + b.rating, 0) / r.length).toFixed(1);
  };
  const getFavCount = (id) => favorites.filter((f) => f.vendorId === id).length;
  const isFav = (id) =>
    user
      ? favorites.some((f) => f.vendorId === id && f.userId === user.uid)
      : false;
  const toggleFavorite = async (id) => {
    if (!user) {
      setShowAuthSheet(true);
      return;
    }
    const already = favorites.find(
      (f) => f.vendorId === id && f.userId === user.uid
    );
    if (already) await deleteDoc(doc(db, "favorites", already.id));
    else
      await addDoc(collection(db, "favorites"), {
        userId: user.uid,
        vendorId: id,
      });
  };

  const resendVerification = async () => {
    try {
      await sendEmailVerification(user);
      alert("✅ Email di verifica inviata! Controlla la tua casella di posta.");
    } catch (e) {
      alert("Errore nell'invio. Riprova tra qualche minuto.");
    }
  };

  const refreshVerification = async () => {
    try {
      await user.reload();
      forceRerender((n) => n + 1);
      if (auth.currentUser?.emailVerified) {
        alert("✅ Email verificata con successo!");
      } else {
        alert("Non risulta ancora verificata. Controlla di aver cliccato il link nell'email.");
      }
    } catch (e) {
      alert("Errore durante il controllo. Riprova.");
    }
  };

  const myTrucks = vendors.filter((v) => v.userId === user?.uid);

  const calcDistance = (lat1, lon1, lat2, lon2) => {
    if (lat1 == null || lon1 == null || lat2 == null || lon2 == null)
      return 9999;
    const R = 6371,
      dLat = ((lat2 - lat1) * Math.PI) / 180,
      dLon = ((lon2 - lon1) * Math.PI) / 180;
    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos((lat1 * Math.PI) / 180) *
        Math.cos((lat2 * Math.PI) / 180) *
        Math.sin(dLon / 2) ** 2;
    return parseFloat(
      (R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))).toFixed(1)
    );
  };

  const moodToCategories = {
    food: [
      "Panini",
      "Pizza",
      "Street Food",
      "Gelato",
      "Dolci",
      "Caffè",
      "Birra",
      "Cocktail",
      "Pesce",
      "Carne",
    ],
    drink: ["Caffè", "Birra", "Cocktail"],
    market: ["Abbigliamento", "Casalinghi", "Frutta e Verdura", "Formaggi", "Altro"],
    gift: ["Fiori", "Abbigliamento", "Altro"],
  };
  const distanceToKm = { near: 0.5, medium: 2, far: 5, any: 9999 };

  const handleWizardSelect = (value) => {
    const newAnswers = {
      ...wizardAnswers,
      [clientSteps[wizardStep].id]: value,
    };
    setWizardAnswers(newAnswers);
    if (wizardStep < clientSteps.length - 1) {
      setWizardStep(wizardStep + 1);
    } else {
      const { mood, distance, now } = newAnswers;
      if (now === "now") setActiveChip("Aperto ora");
      else setActiveChip(null);
      const msgMap = {
        food: "Ecco i migliori food truck vicino a te! 🍔",
        market: "Ho trovato i mercati della zona! 🛒",
        gift: "Perfetto per un regalo speciale! 🌸",
        drink: "Ecco dove bere qualcosa di buono! ☕",
      };
      const distLabel = {
        near: "meno di 500m",
        medium: "meno di 2km",
        far: "meno di 5km",
        any: "ovunque",
      };
      setAssistantMsg(
        `${msgMap[mood] || "Ecco i venditori consigliati!"} Raggio: ${
          distLabel[distance] || "ovunque"
        }.`
      );
      setAssistantChips(["Solo aperti", "Più vicini", "Top rated", "Tutti"]);
      setScreen("main");
    }
  };

  const filteredVendors = vendors
    .map((v) => ({
      ...v,
      avgRating: getAvgRating(v.id),
      reviewCount: reviews.filter((r) => r.vendorId === v.id).length,
      distanceKm: calcDistance(
        userPosition?.[0],
        userPosition?.[1],
        v.lat,
        v.lng
      ),
    }))
    .filter((v) => {
      const catOk =
        selectedCategory === "All" || v.category === selectedCategory;
      const searchOk = (v.name || "")
        .toLowerCase()
        .includes(search.toLowerCase());
      const chipOk =
        !activeChip ||
        (activeChip === "Solo aperti" || activeChip === "Aperto ora"
          ? v.isOpenNow
          : true);
      const maxKm = distanceToKm[wizardAnswers.distance] || 9999;
      const distOk = v.distanceKm <= maxKm;
      const suggestedCats = moodToCategories[wizardAnswers.mood];
      const moodOk =
        !suggestedCats ||
        selectedCategory !== "All" ||
        suggestedCats.includes(v.category);
      const visibleOk = !v.isAdditionalTruck || v.isPremium;
      return catOk && searchOk && chipOk && distOk && moodOk && visibleOk;
    })
    .sort((a, b) => {
      if (activeChip === "Più vicini") return a.distanceKm - b.distanceKm;
      if (activeChip === "Top rated")
        return (b.avgRating || 0) - (a.avgRating || 0);
      if (b.isPremium !== a.isPremium) return b.isPremium ? 1 : -1;
      if (b.isOpenNow !== a.isOpenNow) return b.isOpenNow ? 1 : -1;
      return (b.avgRating || 0) - (a.avgRating || 0);
    });

  if (authLoading)
    return (
      <>
        <style>{style}</style>
        <div
          style={{
            minHeight: "100vh",
            background: "#0a0a0a",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              fontFamily: "'Bebas Neue',sans-serif",
              fontSize: 48,
              color: "#ff6b35",
              letterSpacing: 6,
            }}
          >
            TUK
          </div>
        </div>
      </>
    );

  if (user && userData?.role === "vendor") {
    if (userData.onboardingCompleted === false)
      return (
        <>
          <style>{style}</style>
          <div className="grain" />
          <VendorOnboarding
            user={user}
            onComplete={async () => {
              const snap = await getDoc(doc(db, "users", user.uid));
              if (snap.exists()) setUserData(snap.data());
            }}
          />
        </>
      );
    return (
      <>
        <style>{style}</style>
        <div className="grain" />
        <VendorHome
          user={user}
          myTrucks={myTrucks}
          reviews={reviews}
          onOpenSettings={() => setShowSettings(true)}
        />
      </>
    );
  }

  if (screen === "splash")
    return (
      <>
        <style>{style}</style>
        <div className="grain" />
        {showAuthSheet && (
          <AuthSheet
            onClose={() => setShowAuthSheet(false)}
            onSuccess={(type, role) => {
              setShowAuthSheet(false);
              if (type === "register" && role !== "vendor") setScreen("role");
            }}
          />
        )}
        <div className="splash">
          <div className="logo-wrap">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 0,
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: 300,
                  marginBottom: 6,
                }}
              >
                <div
                  style={{
                    width: 8,
                    height: 8,
                    borderRadius: "50%",
                    background: "#ff6b35",
                    flexShrink: 0,
                  }}
                />
                <div
                  style={{
                    flex: 1,
                    height: 2,
                    background: "rgba(255,107,53,0.35)",
                    margin: "0 6px",
                  }}
                />
                <div
                  style={{
                    width: 8,
                    height: 8,
                    borderRadius: "50%",
                    background: "#ff6b35",
                    flexShrink: 0,
                  }}
                />
              </div>
              <div className="logo-text">TUK</div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: 300,
                  marginTop: 6,
                }}
              >
                <div
                  style={{
                    width: 8,
                    height: 8,
                    borderRadius: "50%",
                    background: "#ff6b35",
                    flexShrink: 0,
                  }}
                />
                <div
                  style={{
                    flex: 1,
                    height: 2,
                    background: "rgba(255,107,53,0.35)",
                    margin: "0 6px",
                  }}
                />
                <div
                  style={{
                    width: 8,
                    height: 8,
                    borderRadius: "50%",
                    background: "#ff6b35",
                    flexShrink: 0,
                  }}
                />
              </div>
              <div style={{ display: "flex", gap: 6, marginTop: 10 }}>
                <div
                  style={{
                    width: 6,
                    height: 6,
                    borderRadius: "50%",
                    background: "#ff6b35",
                    opacity: 0.4,
                  }}
                />
                <div
                  style={{
                    width: 6,
                    height: 6,
                    borderRadius: "50%",
                    background: "#ff6b35",
                  }}
                />
                <div
                  style={{
                    width: 6,
                    height: 6,
                    borderRadius: "50%",
                    background: "#ff6b35",
                    opacity: 0.4,
                  }}
                />
              </div>
              <div
                className="logo-sub"
                style={{ letterSpacing: 5, marginTop: 8 }}
              >
                IL MERCATO IN MOVIMENTO
              </div>
            </div>
          </div>
          <div className="splash-title">TROVA CHI VENDE VICINO A TE</div>
          <div className="splash-sub">
            Food truck, fioristi, mercati ambulanti. Sempre aggiornati, sempre
            in movimento.
          </div>
          {user ? (
            <button className="btn-primary" onClick={() => setScreen("role")}>
              CONTINUA →
            </button>
          ) : (
            <button
              className="btn-primary"
              onClick={() => setShowAuthSheet(true)}
            >
              INIZIA ORA
            </button>
          )}
          <button
            className="btn-secondary"
            style={{ marginTop: 12 }}
            onClick={() => setScreen("main")}
          >
            Esplora senza account
          </button>
          {user && (
            <button
              className="btn-ghost"
              style={{ marginTop: 8 }}
              onClick={() => signOut(auth)}
            >
              Esci ({user.email})
            </button>
          )}
        </div>
      </>
    );

  if (screen === "role")
    return (
      <>
        <style>{style}</style>
        <div className="grain" />
        <div className="splash">
          <div className="logo-wrap" style={{ marginBottom: 32 }}>
            <div className="logo-text" style={{ fontSize: 52 }}>
              TUK
            </div>
          </div>
          <div className="splash-title">
            COSA STAI
            <br />
            CERCANDO?
          </div>
          <div className="splash-sub">Ti guido verso i venditori giusti.</div>
          <button
            className="btn-primary"
            onClick={() => {
              setWizardStep(0);
              setScreen("wizard");
            }}
          >
            🔍 CERCA CON L'ASSISTENTE
          </button>
          <button
            className="btn-secondary"
            style={{ marginTop: 12 }}
            onClick={() => setScreen("main")}
          >
            Esplora liberamente
          </button>
          <button
            className="btn-ghost"
            style={{ marginTop: 8 }}
            onClick={() => setScreen("splash")}
          >
            ← Indietro
          </button>
        </div>
      </>
    );

  if (screen === "wizard")
    return (
      <>
        <style>{style}</style>
        <div className="grain" />
        <WizardStep
          step={clientSteps[wizardStep]}
          stepIndex={wizardStep}
          totalSteps={clientSteps.length}
          onSelect={handleWizardSelect}
          onBack={() => {
            if (wizardStep === 0) setScreen("role");
            else setWizardStep(wizardStep - 1);
          }}
        />
      </>
    );

  if (selectedTruck)
    return (
      <>
        <style>{style}</style>
        <div className="grain" />
        <TruckDetail
          vendor={{
            ...selectedTruck,
            avgRating: getAvgRating(selectedTruck.id),
            reviewCount: reviews.filter((r) => r.vendorId === selectedTruck.id)
              .length,
          }}
          reviews={reviews}
          favCount={getFavCount(selectedTruck.id)}
          user={user}
          userData={userData}
          onBack={() => setSelectedTruck(null)}
        />
      </>
    );

  return (
    <>
      <style>{style}</style>
      <div className="grain" />
      {showAuthSheet && (
        <AuthSheet
          onClose={() => setShowAuthSheet(false)}
          onSuccess={() => setShowAuthSheet(false)}
        />
      )}
      <div className="app">
        <div className="topbar">
          <div className="topbar-logo">
            <img src="/logo-header.png" alt="Tuk" style={{width:32,height:32,borderRadius:7,objectFit:"cover"}} />
          </div>
          <div className="search-wrap">
            <span className="search-icon">🔍</span>
            {locationUnavailable && (
              <div
                style={{
                  background: "#fff3cd",
                  color: "#856404",
                  padding: "8px 14px",
                  margin: 5,
                  borderRadius: 10,
                  fontSize: 14,
                }}
              >
                📍 Posizione non disponibile — attiva la localizzazione per vedere i truck vicino a te
              </div>
            )}

            <input
              className="topbar-search"
              placeholder="Cerca venditori..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          <button
            className="avatar-btn"
            onClick={() => (user ? signOut(auth) : setShowAuthSheet(true))}
          >
            {user ? "🧑" : "🔑"}
          </button>
        </div>
        {activeNav === "map" && (
          <>
            <div className="assistant-banner">
        {(Object.keys(wizardAnswers).length > 0 || activeChip) && (
          <button
            className="assistant-close-btn"
            title="Reimposta filtri e assistente"
            onClick={() => {
              setWizardAnswers({});
              setActiveChip(null);
              setSelectedCategory("All");
              setAssistantMsg("Ciao! Cosa stai cercando oggi? 👇");
              setAssistantChips(["Aperto ora", "Vicino a me", "Top rated"]);
            }}
          >
            ✕
          </button>
        )}
              <div className="assistant-row">
                <div className="assistant-avatar">🤖</div>
                <div className="assistant-bubble">
                  <div className="assistant-name">Tuk Assistant</div>
                  <div className="assistant-msg">
                    {assistantMsg}
                    {filteredVendors.length > 0 ? (
                      <span
                        style={{
                          display: "block",
                          fontSize: 12,
                          color: "var(--orange)",
                          marginTop: 4,
                          fontWeight: 600,
                        }}
                      >
                        {filteredVendors.length}{" "}
                        {filteredVendors.length === 1
                          ? "venditore trovato"
                          : "venditori trovati"}
                        {filteredVendors.filter((v) => v.isOpenNow).length >
                          0 &&
                          ` · ${
                            filteredVendors.filter((v) => v.isOpenNow).length
                          } aperti ora`}
                      </span>
                    ) : vendors.length > 0 ? (
                      <span
                        style={{
                          display: "block",
                          fontSize: 12,
                          color: "var(--muted)",
                          marginTop: 4,
                        }}
                      >
                        Nessun risultato — prova ad allargare i filtri.
                      </span>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="assistant-chips">
                {assistantChips.map((chip) => (
                  <button
                    key={chip}
                    className={`chip ${activeChip === chip ? "active" : ""}`}
                    onClick={() => {
                      if (chip === "Tutti") {
                        setActiveChip(null);
                        setSelectedCategory("All");
                        setWizardAnswers({});
                      } else setActiveChip(activeChip === chip ? null : chip);
                    }}
                  >
                    {chip}
                  </button>
                ))}
              </div>
            </div>
            <TruckyMap
              vendors={filteredVendors}
              onOpenTruck={setSelectedTruck}
              userPosition={userPosition}
            />
            <div className="cat-strip">
              {categories.map((c) => (
                <button
                  key={c.label}
                  className={`cat-pill ${
                    selectedCategory === c.label ? "active" : ""
                  }`}
                  onClick={() => setSelectedCategory(c.label)}
                >
                  {c.emoji} {c.label}
                </button>
              ))}
            </div>
            <div className="trucks-section">
              <div className="section-header">
                <div className="section-title">VICINO A TE</div>
                <div className="section-count">
                  {filteredVendors.length} risultati
                </div>
              </div>
              {vendors.length === 0 ? (
                <div className="loading">⏳ Caricamento...</div>
              ) : filteredVendors.length === 0 ? (
                <div className="empty-state">
                  <div className="empty-state-icon">🔍</div>
                  <div className="empty-state-text">
                    Nessun venditore trovato.
                    <br />
                    Prova a cambiare i filtri.
                  </div>
                </div>
              ) : (
                <div className="trucks-list">
                  {filteredVendors.map((v) => (
                    <TruckCard
                      key={v.id}
                      vendor={v}
                      onOpen={setSelectedTruck}
                      onFavorite={toggleFavorite}
                      isFav={isFav(v.id)}
                      favCount={getFavCount(v.id)}
                    />
                  ))}
                </div>
              )}
            </div>
          </>
        )}
        {activeNav === "favorites" && (
          <div className="trucks-section" style={{ paddingTop: 20 }}>
            <div className="section-header">
              <div className="section-title">PREFERITI</div>
              <div className="section-count">
                {user
                  ? favorites.filter((f) => f.userId === user.uid).length
                  : 0}{" "}
                salvati
              </div>
            </div>
            {!user ? (
              <div className="empty-state">
                <div className="empty-state-icon">🔑</div>
                <div className="empty-state-text">
                  Accedi per vedere i tuoi preferiti.
                </div>
                <button
                  className="btn-primary"
                  style={{ marginTop: 16, fontSize: 16 }}
                  onClick={() => setShowAuthSheet(true)}
                >
                  ACCEDI
                </button>
              </div>
            ) : favorites.filter((f) => f.userId === user.uid).length === 0 ? (
              <div className="empty-state">
                <div className="empty-state-icon">🤍</div>
                <div className="empty-state-text">Nessun preferito ancora.</div>
              </div>
            ) : (
              <div className="trucks-list">
                {vendors
                  .filter((v) => isFav(v.id))
                  .map((v) => (
                    <TruckCard
                      key={v.id}
                      vendor={v}
                      onOpen={setSelectedTruck}
                      onFavorite={toggleFavorite}
                      isFav
                      favCount={getFavCount(v.id)}
                    />
                  ))}
              </div>
            )}
          </div>
        )}

        {activeNav === "profile" && (
          <div style={{ padding: 24, textAlign: "center", paddingBottom: 100 }}>
            <div style={{ fontSize: 64, marginBottom: 16 }}>
              {user ? "🧑" : "🔑"}
            </div>
            {user ? (
              <>
                <div
                  style={{
                    fontFamily: "var(--font-display)",
                    fontSize: 28,
                    letterSpacing: 2,
                    marginBottom: 4,
                  }}
                >
                  CLIENTE
                </div>
                <AvatarUploader user={user} currentPhoto={userData?.photoURL} />
                {!user.emailVerified && (
                  <div
                    style={{
                      background: "rgba(255,193,7,0.1)",
                      border: "1px solid rgba(255,193,7,0.3)",
                      borderRadius: "var(--radius-sm)",
                      padding: "14px 16px",
                      marginBottom: 20,
                      textAlign: "left",
                    }}
                  >
                    <div style={{ fontSize: 14, color: "var(--cream)", fontWeight: 600, marginBottom: 4 }}>
                      📧 Verifica la tua email
                    </div>
                    <div style={{ fontSize: 12, color: "var(--muted)", marginBottom: 10 }}>
                      Conferma il tuo indirizzo per non perderti aggiornamenti e novità.
                    </div>
                    <div style={{ display: "flex", gap: 8 }}>
                      <button
                        onClick={resendVerification}
                        style={{
                          flex: 1,
                          padding: "8px",
                          borderRadius: 8,
                          border: "1px solid var(--border)",
                          background: "transparent",
                          color: "var(--cream)",
                          fontSize: 12,
                          fontWeight: 600,
                          cursor: "pointer",
                        }}
                      >
                        Rinvia email
                      </button>
                      <button
                        onClick={refreshVerification}
                        style={{
                          flex: 1,
                          padding: "8px",
                          borderRadius: 8,
                          border: "none",
                          background: "var(--orange)",
                          color: "white",
                          fontSize: 12,
                          fontWeight: 600,
                          cursor: "pointer",
                        }}
                      >
                        Ho verificato
                      </button>
                    </div>
                  </div>
                )}
                <div
                  style={{
                    color: "var(--muted)",
                    fontSize: 14,
                    marginBottom: 32,
                  }}
                >
                  {user.email}
                </div>
                <button
                  className="btn-secondary"
                  style={{ maxWidth: "100%" }}
                  onClick={() => {
                    signOut(auth);
                    setScreen("splash");
                  }}
                >
                  Esci dall'account
                </button>
                <div style={{marginTop:32,width:"100%",textAlign:"left"}}>
                  <div style={{fontSize:11,letterSpacing:3,textTransform:"uppercase",color:"var(--orange)",fontWeight:600,marginBottom:12}}>I miei coupon</div>
                  <MyCoupons user={user} vendors={vendors} onOpenTruck={setSelectedTruck} />
                </div>
                <div style={{marginTop:24,display:"flex",flexDirection:"column",gap:10}}>
                  <a href="https://trucky-96c2f.web.app/privacy.html" target="_blank" rel="noreferrer" style={{color:"var(--muted)",fontSize:13,textAlign:"center",textDecoration:"none"}}>Privacy Policy</a>
                  <a href="https://trucky-96c2f.web.app/termini.html" target="_blank" rel="noreferrer" style={{color:"var(--muted)",fontSize:13,textAlign:"center",textDecoration:"none"}}>Termini e Condizioni</a>
                  <a href="https://trucky-96c2f.web.app/rimborsi.html" target="_blank" rel="noreferrer" style={{color:"var(--muted)",fontSize:13,textAlign:"center",textDecoration:"none"}}>Politica di Rimborso</a>
                  <a href="https://trucky-96c2f.web.app/prezzi.html" target="_blank" rel="noreferrer" style={{color:"var(--muted)",fontSize:13,textAlign:"center",textDecoration:"none"}}>Prezzi Premium</a>
                </div>
              </>
            ) : (
              <>
                <div
                  style={{
                    fontFamily: "var(--font-display)",
                    fontSize: 28,
                    letterSpacing: 2,
                    marginBottom: 8,
                  }}
                >
                  OSPITE
                </div>
                <div
                  style={{
                    color: "var(--muted)",
                    fontSize: 14,
                    marginBottom: 32,
                  }}
                >
                  Accedi per sbloccare tutte le funzioni
                </div>
                <button
                  className="btn-primary"
                  style={{ fontSize: 18 }}
                  onClick={() => setShowAuthSheet(true)}
                >
                  ACCEDI / REGISTRATI
                </button>
              </>
            )}
          </div>
        )}
        <div className="bottom-nav">
          {[
            { id: "map", icon: "🗺️", label: "Scopri" },
            { id: "favorites", icon: "❤️", label: "Preferiti" },
            { id: "profile", icon: "👤", label: "Profilo" },
          ].map((item) => (
            <button
              key={item.id}
              className={`nav-item ${activeNav === item.id ? "active" : ""}`}
              onClick={() => setActiveNav(item.id)}
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label">{item.label}</span>
            </button>
          ))}
        </div>
      </div>
    </>
  );
}
